/* Novomur Studio (pilote, 12/10/2026) : la fiche simplifiée de sections/novomur-studio.liquid.
   Un seul projet (design, mesures, cadrage, finition), affiché de deux façons : les photos de l'annonce
   et la photo du mur du client. Le panier reçoit les 12 propriétés de la fiche classique, à l'identique :
   même commande, même brouillon de paiement par le tiroir. */
(function () {
'use strict';
var root = document.getElementById('nms');
if (!root || root.getAttribute('data-ready')) return;
root.setAttribute('data-ready', '1');
var D;
try { D = JSON.parse(document.getElementById('nmsData').textContent); } catch (e) { return; }
if (!D.variants || !D.variants.length) return;

var $ = function (id) { return document.getElementById(id); };
var MARGIN_CM = 10;                 // marge de pose ajoutée et facturée, comme la fiche classique
var DEF_W = 300, DEF_H = 250;       // mur indicatif tant que le client n'a pas saisi ses mesures
var FREE = Math.max(0, +D.murGratuits || 3);
// Rendu par l'IA sur la photo du client (worker novomur-studio). Vide : aperçu 3D sur l'appareil (designs offerts puis numéro).
var IA = String(D.iaUrl || '').trim().replace(/\/+$/, '');
if (IA && !document.getElementById('nmsIa')) IA = '';
var IA_FREE = Math.max(0, +D.iaFree || 3);
// Liste Klaviyo (worker novomur-newsletter, comme le pied de page et la pop-up) : seulement sur case cochée.
var NEWS = 'https://novomur-newsletter.novomur.workers.dev/';

var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
var fmt2 = function (n) { return n.toFixed(2).replace('.', ','); };
var eur = function (n) {
  try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n); }
  catch (e) { return fmt2(n) + ' €'; }
};

/* ---------- Éléments ---------- */
var stage = $('nmsStage'), hero = $('nmsHero'), note = $('nmsNote');
var wIn = $('nmsW'), hIn = $('nmsH'), dimsErr = $('nmsDimsErr'), recap = $('nmsRecap');
var cropIn = $('nmsCropIn'), cropImg = $('nmsCropImg'), frameEl = $('nmsFrame'), zoomIn = $('nmsZoom'), mirrorBtn = $('nmsMirror');
var frameDim = $('nmsFrameDim'), frameDimTxt = $('nmsFrameDimTxt'), mirrorNote = $('nmsMirrorNote');
var persBtn = $('nmsPersBtn'), persEl = $('nmsPers'), persOn = false;
var cta = $('nmsCta'), barLabel = $('nmsBarLabel'), barTotal = $('nmsBarTotal'), cartErr = $('nmsCartErr'), otherWall = $('nmsOtherWall');
var buy = $('nmsBuy'), buyText = $('nmsBuyText'), BUY_LABEL = buyText.textContent;

/* ---------- Projet ---------- */
var byId = {};
D.variants.forEach(function (v) { byId[v.id] = v; });
var st = {
  v: byId[D.current] || D.variants[0],
  mat: 'Intissé lisse',
  crops: {},          // par design : { cx, cy, z, m } (centre du cadre en fraction du design, zoom, miroir)
  view: 'photo',
  photoIdx: 0,
  before: false
};

var KEY = 'nms:' + D.productId;
(function restore() {
  var o = null;
  try { o = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
  if (!o || typeof o !== 'object') return;
  if (o.w > 0) wIn.value = o.w;
  if (o.h > 0) hIn.value = o.h;
  if (typeof o.mat === 'string') {
    var r = root.querySelector('input[name="nmsMat"][value="' + o.mat.replace(/"/g, '') + '"]');
    if (r) { r.checked = true; st.mat = o.mat; }
  }
  if (o.crops && typeof o.crops === 'object') {
    Object.keys(o.crops).forEach(function (k) {
      var c = o.crops[k];
      if (c && isFinite(c.cx) && isFinite(c.cy) && isFinite(c.z)) st.crops[k] = { cx: +c.cx, cy: +c.cy, z: clamp(+c.z, 1, 3), m: !!c.m };
    });
  }
})();
var saveT = 0;
function persist() {
  clearTimeout(saveT);
  saveT = setTimeout(function () {
    var d = dims();
    try {
      localStorage.setItem(KEY, JSON.stringify({ w: d.wOk ? d.w : null, h: d.hOk ? d.h : null, mat: st.mat, crops: st.crops }));
    } catch (e) {}
  }, 300);
}

/* ---------- Mesures ---------- */
function num(input) {
  var s = String(input.value || '').replace(',', '.').trim();
  if (!s) return null;
  var n = parseFloat(s);
  return isFinite(n) ? n : NaN;
}
function dims() {
  var w = num(wIn), h = num(hIn);
  var wOk = w !== null && w === w && w >= D.minW && w <= D.maxW;
  var hOk = h !== null && h === h && h >= D.minH && h <= D.maxH;
  return { w: w, h: h, wOk: wOk, hOk: hOk, wEmpty: w === null, hEmpty: h === null, valid: wOk && hOk };
}
function effDims() {
  var d = dims();
  return { w: d.wOk ? d.w : DEF_W, h: d.hOk ? d.h : DEF_H, real: d.valid };
}
function matPrice() {
  var r = root.querySelector('input[name="nmsMat"]:checked');
  var p = r ? parseFloat(r.getAttribute('data-price')) : 0;
  return p > 0 ? p : (+D.priceM2 || 29.9);
}
var dimsMsg = 'Dimensions acceptées : largeur de ' + D.minW + ' à ' + D.maxW + ' cm, hauteur de ' + D.minH + ' à ' + D.maxH + ' cm.';
function showDimsErr(force) {
  var d = dims();
  var wBad = !d.wEmpty && !d.wOk, hBad = !d.hEmpty && !d.hOk;
  if (force) { wBad = wBad || d.wEmpty; hBad = hBad || d.hEmpty; }
  wIn.setAttribute('aria-invalid', wBad ? 'true' : 'false');
  hIn.setAttribute('aria-invalid', hBad ? 'true' : 'false');
  var bad = (wBad && !d.wEmpty) || (hBad && !d.hEmpty);
  dimsErr.textContent = bad ? dimsMsg : (wBad || hBad ? 'Saisissez la largeur et la hauteur de votre mur.' : '');
  dimsErr.hidden = !(wBad || hBad);
  return wBad ? wIn : (hBad ? hIn : null);
}

/* ---------- Cadrage ---------- */
var imgCache = {};
function loadImg(src) {
  return new Promise(function (res, rej) {
    var i = new Image();
    i.crossOrigin = 'anonymous';
    i.decoding = 'async';
    i.onload = function () { res(i); };
    i.onerror = function () { rej(new Error('image')); };
    i.src = src;
  });
}
function designImg(v) {
  if (!imgCache[v.code]) {
    imgCache[v.code] = loadImg(v.design.src);
    imgCache[v.code].catch(function () { delete imgCache[v.code]; });
  }
  return imgCache[v.code];
}
function designAR(v) {
  var w = v.design.nw || v.design.w, h = v.design.nh || v.design.h;
  return w > 0 && h > 0 ? w / h : 1.6;
}
function cropOf(code) {
  return st.crops[code] || (st.crops[code] = { cx: 0.5, cy: 0.5, z: 1, m: false });
}
/* Le cadre a le format du mur (largeur / hauteur saisies, sans la marge, comme la fiche classique),
   le plus grand possible dans le design, divisé par le zoom. Le centre est ramené dans le design. */
function frame(v) {
  var c = cropOf(v.code), e = effDims();
  var A = designAR(v), R = e.w / e.h;
  var fw = 1, fh = 1;
  if (R >= A) fh = A / R; else fw = R / A;
  fw /= c.z; fh /= c.z;
  c.cx = clamp(c.cx, fw / 2, 1 - fw / 2);
  c.cy = clamp(c.cy, fh / 2, 1 - fh / 2);
  return { x: c.cx - fw / 2, y: c.cy - fh / 2, w: fw, h: fh, m: c.m };
}
function engineCrop(f) { return f.m ? [f.x + f.w, f.y, -f.w, f.h] : [f.x, f.y, f.w, f.h]; }
/* L'étape 2 n'apparaît qu'avec des mesures valides : le cadre a alors le format exact du mur.
   Pendant la saisie, une valeur incomplète (« 3 » avant « 300 ») ne la masque pas : seulement à la sortie du champ. */
var cropBody = $('nmsCropBody'), cropWait = $('nmsCropWait');
function cropGate(force) {
  var ok = dims().valid;
  if (!ok && !force && !cropBody.hidden && (document.activeElement === wIn || document.activeElement === hIn)) return;
  cropBody.hidden = !ok;
  cropWait.hidden = ok;
}

/* ---------- Rendu groupé ---------- */
var raf = 0;
function render() {
  if (raf) return;
  raf = requestAnimationFrame(function () { raf = 0; renderNow(); });
}
function renderNow() {
  var v = st.v, f = frame(v), c = cropOf(v.code);
  // Widget du cadrage
  cropIn.style.setProperty('--nms-dar', designAR(v).toFixed(4));
  cropIn.classList.toggle('is-mirror', c.m);
  frameEl.style.left = (f.x * 100) + '%';
  frameEl.style.top = (f.y * 100) + '%';
  frameEl.style.width = (f.w * 100) + '%';
  frameEl.style.height = (f.h * 100) + '%';
  var px = Math.round(c.cx * 100), py = Math.round(c.cy * 100);
  frameEl.setAttribute('aria-valuenow', String(px));
  // Le cadre, c'est le mur du client : ses cotes dessus, et dans ce que lit un lecteur d'écran
  var d = dims();
  if (frameDim) { frameDim.hidden = !d.valid; frameDimTxt.textContent = d.valid ? fmtCm(d.w) + ' \u00d7 ' + fmtCm(d.h) + ' cm' : ''; }
  // Une personne de 1,65 m (50 cm de large) debout au pied du mur, à l'échelle du cadre ; seulement si elle y tient en hauteur
  var persOk = d.valid && d.h >= 165;
  if (persBtn) { persBtn.hidden = !persOk; persBtn.setAttribute('aria-pressed', persOn ? 'true' : 'false'); }
  if (persEl) {
    persEl.hidden = !(persOn && persOk);
    if (persOk) { persEl.style.height = (16500 / d.h).toFixed(2) + '%'; persEl.style.width = (5000 / d.w).toFixed(2) + '%'; }
  }
  frameEl.setAttribute('aria-valuetext', ((px === 50 && py === 50) ? 'centré' : ('à ' + px + ' % de la largeur, ' + py + ' % de la hauteur')) +
    (d.valid ? ', mur de ' + fmtCm(d.w) + ' par ' + fmtCm(d.h) + ' cm' : ''));
  if (mirrorNote) mirrorNote.hidden = !c.m;
  zoomIn.value = String(Math.round(c.z * 100));
  zoomIn.setAttribute('aria-valuetext', c.z <= 1.001 ? "taille d'origine" : ('motif agrandi ' + String(Math.round(c.z * 100)) + ' %'));
  mirrorBtn.setAttribute('aria-pressed', c.m ? 'true' : 'false');
  updateBar();
  cropGate(false);
  if (murOn() && mur.engine && mur.shown === v.code) mur.engine.setCrop(engineCrop(f));
  updateNote();
  // Avec l'IA, le bouton de rendu et la photo affichée suivent le design, le cadrage et les mesures.
  if (IA) murUi();
  persist();
}

/* ---------- Barre d'achat ---------- */
var murId = newMurId(), murNum = 1, murAjoute = false, busy = false;
function newMurId() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }
window.ppCurrentProductId = D.productId;
function addLabel() {
  if (murAjoute) return murNum > 1 ? 'Mettre à jour le mur ' + murNum : 'Mettre à jour ce mur';
  return murNum > 1 ? 'Ajouter le mur ' + murNum + ' au panier' : 'Ajouter au panier';
}
function ctaMode() {
  var d = dims();
  if (!st.v.ok) return 'off';
  if (d.wEmpty || d.hEmpty) return 'enter';
  if (!d.valid) return 'fix';
  return 'add';
}
function updateBar() {
  var d = dims(), p = matPrice();
  if (d.valid) {
    var m2 = ((d.w + MARGIN_CM) / 100) * ((d.h + MARGIN_CM) / 100);
    barLabel.textContent = st.mat + ' · ' + fmt2(m2) + ' m²';
    barTotal.textContent = eur(m2 * p);
    recap.textContent = 'Papier imprimé : ' + fmtCm(d.w + MARGIN_CM) + ' × ' + fmtCm(d.h + MARGIN_CM) + ' cm, soit ' + fmt2(m2) + ' m².';
    recap.hidden = false;
  } else {
    barLabel.textContent = st.mat;
    barTotal.textContent = fmt2(p) + ' €/m²';
    recap.hidden = true;
  }
  if (busy) return;
  var mode = ctaMode();
  cta.disabled = mode === 'off';
  cta.textContent = mode === 'off' ? 'Design indisponible' : mode === 'enter' ? 'Saisir mes mesures' : mode === 'fix' ? 'Corriger mes mesures' : addLabel();
  cta.setAttribute('data-mode', mode);
  buy.disabled = mode === 'off';
  buy.classList.remove('is-busy');
  buyText.textContent = BUY_LABEL;
  otherWall.hidden = !murAjoute;
  sampleUi();
  projUi();
}
function fmtCm(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }

/* ---------- Note sur la scène ---------- */
function updateNote() {
  var e = effDims(), t = '';
  if (!IA && murOn() && mur.photo && !mur.gated && !e.real) {
    t = 'Format indicatif ' + e.w + ' × ' + e.h + ' cm : saisissez vos mesures';
  }
  note.textContent = st.view === 'mur' ? t : '';
  note.hidden = !note.textContent;
  $('nmsTryNote').textContent = t || (IA ? 'Rendu indicatif sur votre photo' : 'Aperçu indicatif sur votre photo');
}

/* ---------- Vue « Photos » : les photos de l'annonce ---------- */
function photosOf(v) {
  if (v.photos && v.photos.length) return v.photos;
  return [{ s: v.design.src, l: v.design.src, w: v.design.w, h: v.design.h, a: 'Design ' + v.code }];
}
function showPhoto(i) {
  if (!hero) return;
  var ps = photosOf(st.v);
  st.photoIdx = (i + ps.length) % ps.length;
  var p = ps[st.photoIdx];
  hero.removeAttribute('srcset');
  hero.src = p.s;
  if (p.l && p.l !== p.s) hero.srcset = p.s + ' 900w, ' + p.l + ' 1400w';
  if (p.w && p.h) { hero.width = p.w; hero.height = p.h; stage.style.setProperty('--nms-photo-ar', p.w + ' / ' + p.h); }
  hero.alt = p.a || ('Design ' + st.v.code);
  photoNav();
}
function photoNav() {
  var n = photosOf(st.v).length;
  $('nmsPhotoNav').hidden = n < 2;
  $('nmsPhotoCount').textContent = (st.photoIdx + 1) + ' / ' + n;
  thumbsSync();
}

/* ---------- Vignettes sous la grande photo (même changement de photo que les flèches : showPhoto) ---------- */
var thumbs = $('nmsThumbs');
function thumbsBuild(ps) {
  // La rangée du design affiché vient du serveur ; elle est refaite au changement de design.
  var n = ps.length, keep = thumbs && thumbs.getAttribute('data-for') === String(st.v.id) && thumbs.children.length === n;
  if (keep) return;
  if (!thumbs) {
    var stg = $('nmsStage');
    if (!stg || !hero || n < 2) return;
    thumbs = document.createElement('div');
    thumbs.id = 'nmsThumbs';
    thumbs.className = 'nms__thumbs';
    thumbs.setAttribute('role', 'group');
    thumbs.setAttribute('aria-label', 'Choisir une photo');
    stg.parentNode.insertBefore(thumbs, stg.nextSibling);
  }
  thumbs.textContent = '';
  thumbs.setAttribute('data-for', String(st.v.id));
  ps.forEach(function (p, i) {
    var b = document.createElement('button'), im = document.createElement('img');
    b.type = 'button';
    b.className = 'nms__thumb';
    b.setAttribute('data-photo-go', i);
    b.setAttribute('aria-label', 'Voir la photo ' + (i + 1) + ' sur ' + n);
    im.src = p.t || p.s;
    im.width = 160; im.height = 120;
    im.alt = 'Ambiance ' + (i + 1) + ' de ' + n;
    im.loading = 'lazy'; im.decoding = 'async';
    b.appendChild(im);
    thumbs.appendChild(b);
  });
}
function thumbsReveal() {
  // La vignette active reste visible : on décale la rangée (scrollLeft ; scrollIntoView est inopérant sur la fiche).
  if (!thumbs || thumbs.hidden || !thumbs.clientWidth) return;
  var b = thumbs.children[st.photoIdx];
  if (!b) return;
  // Cible = un point d'accroche du scroll-snap (début de la vignette moins la marge) : sinon le navigateur ramène la rangée en arrière.
  var pad = parseFloat(getComputedStyle(thumbs).paddingLeft) || 0, l = b.offsetLeft, r = l + b.offsetWidth, v = thumbs.scrollLeft, w = thumbs.clientWidth, x = v;
  if (l - pad < v || r + pad > v + w) x = l - pad;
  x = clamp(x, 0, thumbs.scrollWidth - w);
  if (Math.abs(x - v) > 1) thumbs.scrollLeft = x;
}
function thumbsSync() {
  var ps = photosOf(st.v), on = ps.length > 1 && !!hero;
  if (on) thumbsBuild(ps);
  if (!thumbs) return;
  thumbs.hidden = !on;
  if (!on) return;
  Array.prototype.forEach.call(thumbs.children, function (b, i) {
    if (i === st.photoIdx) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
  });
  thumbsReveal();
}
if (thumbs) thumbs.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-photo-go]');
  if (b) showPhoto(+b.getAttribute('data-photo-go'));
});

/* ---------- Glisser pour décaler le motif sur le mur du client ---------- */
function dragWall(el, toDelta) {
  el.addEventListener('pointerdown', function (e) {
    if (e.button !== undefined && e.button !== 0) return;
    if (mur.editing && el === $('nmsMurEngine')) return;
    var start = toDelta.start(e);
    if (!start) return;
    var c = cropOf(st.v.code), cx0 = c.cx, cy0 = c.cy, touch = e.pointerType === 'touch';
    try { el.setPointerCapture(e.pointerId); } catch (x) {}
    el.classList.add('is-dragging');
    function move(ev) {
      var d = toDelta.move(ev, start);
      if (!d) return;
      var f = frame(st.v), sg = c.m ? 1 : -1;
      c.cx = cx0 + sg * d[0] * f.w;
      if (!touch) c.cy = cy0 - d[1] * f.h;
      render();
    }
    function up() {
      el.removeEventListener('pointermove', move);
      el.removeEventListener('pointerup', up);
      el.removeEventListener('pointercancel', up);
      el.classList.remove('is-dragging');
    }
    el.addEventListener('pointermove', move);
    el.addEventListener('pointerup', up);
    el.addEventListener('pointercancel', up);
  });
}
// Mur du client : la position sur le mur redressé (0..1), perspective comprise.
dragWall($('nmsMurEngine'), {
  start: function (e) {
    if (!mur.engine || !mur.photo || mur.gated || iaShown() || (ia && ia.busy)) return null;
    var uv = mur.engine.uvAt(e.clientX, e.clientY);
    return uv ? { uv: uv } : null;
  },
  move: function (e, s) {
    var uv = mur.engine.uvAt(e.clientX, e.clientY);
    return uv ? [uv[0] - s.uv[0], uv[1] - s.uv[1]] : null;
  }
});

// Widget : on déplace le cadre (le cadre suit le doigt). Toucher hors du cadre l'y amène.
cropIn.addEventListener('pointerdown', function (e) {
  if (e.button !== undefined && e.button !== 0) return;
  e.preventDefault();
  var c = cropOf(st.v.code), r = cropIn.getBoundingClientRect();
  var u = (e.clientX - r.left) / r.width, vv = (e.clientY - r.top) / r.height;
  if (c.m) u = 1 - u;
  if (!(e.target.closest && e.target.closest('#nmsFrame'))) { c.cx = u; c.cy = vv; render(); }
  var cx0 = c.cx, cy0 = c.cy, x0 = e.clientX, y0 = e.clientY;
  try { cropIn.setPointerCapture(e.pointerId); } catch (x) {}
  cropIn.classList.add('is-dragging');
  frameEl.focus({ preventScroll: true });
  function move(ev) {
    c.cx = cx0 + (c.m ? -1 : 1) * (ev.clientX - x0) / r.width;
    c.cy = cy0 + (ev.clientY - y0) / r.height;
    render();
  }
  function up() {
    cropIn.removeEventListener('pointermove', move);
    cropIn.removeEventListener('pointerup', up);
    cropIn.removeEventListener('pointercancel', up);
    cropIn.classList.remove('is-dragging');
  }
  cropIn.addEventListener('pointermove', move);
  cropIn.addEventListener('pointerup', up);
  cropIn.addEventListener('pointercancel', up);
});
frameEl.addEventListener('keydown', function (e) {
  var k = e.key, step = e.shiftKey ? 0.1 : 0.02, c = cropOf(st.v.code), sg = c.m ? -1 : 1;
  if (k === 'ArrowLeft') c.cx -= step * sg;
  else if (k === 'ArrowRight') c.cx += step * sg;
  else if (k === 'ArrowUp') c.cy -= step;
  else if (k === 'ArrowDown') c.cy += step;
  else if (k === 'Home') { c.cx = 0.5; c.cy = 0.5; }
  else return;
  e.preventDefault();
  render();
});
zoomIn.addEventListener('input', function () {
  cropOf(st.v.code).z = clamp((+zoomIn.value || 100) / 100, 1, 3);
  render();
});
$('nmsRecenter').addEventListener('click', function () {
  var c = cropOf(st.v.code); c.cx = 0.5; c.cy = 0.5;
  render();
});
mirrorBtn.addEventListener('click', function () {
  var c = cropOf(st.v.code); c.m = !c.m;
  render();
});
if (persBtn) persBtn.addEventListener('click', function () { persOn = !persOn; render(); });

/* ---------- Mesures et finition ---------- */
function onDims() {
  if (!dimsErr.hidden) showDimsErr(false);
  render();
}
wIn.addEventListener('input', onDims);
hIn.addEventListener('input', onDims);
wIn.addEventListener('change', function () { showDimsErr(false); });
hIn.addEventListener('change', function () { showDimsErr(false); });
// À la sortie du champ (« change » ne part pas si la valeur revient à celle d'avant la saisie).
wIn.addEventListener('blur', function () { cropGate(true); });
hIn.addEventListener('blur', function () { cropGate(true); });
root.querySelectorAll('input[name="nmsMat"]').forEach(function (r) {
  r.addEventListener('change', function () { if (r.checked) { st.mat = r.value; render(); } });
});

/* ---------- « Mon art » : choix importer / créer, dans une fenêtre ---------- */
(function () {
  var own = $('nmsOwn'), dlg = $('nmsArt');
  if (!own || !dlg) return;
  function close() { if (dlg.open) dlg.close(); }
  own.addEventListener('click', function (e) {
    // Navigateur sans <dialog> : on va directement à l'import d'image.
    if (typeof dlg.showModal !== 'function') { window.location.href = own.getAttribute('data-href'); return; }
    window.ppVerrou('art', true); // verrou partagé (theme.liquid) : un tiroir ouvert derrière garde la page bloquée
    dlg.showModal();
    // Au doigt ou à la souris, pas d'anneau de focus sur « Fermer » : le focus va à la fenêtre (Tab mène ensuite aux choix).
    if (e.detail !== 0) dlg.focus();
  });
  dlg.addEventListener('close', function () {
    window.ppVerrou('art', false);
    own.focus({ preventScroll: true });
  });
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || (e.target.closest && e.target.closest('[data-art-close]'))) close();
  });
  // Retour arrière depuis la page d'import (cache du navigateur) : la fenêtre ne doit pas rester ouverte.
  window.addEventListener('pageshow', function (e) { if (e.persisted) close(); });
})();

/* ---------- Plein écran : les photos du design puis le motif entier, ou l'aperçu sur le mur du client ;
   pincer, double toucher, molette ---------- */
(function () {
  var dlg = $('nmsLb'), view = $('nmsLbView'), img = $('nmsLbImg'), count = $('nmsLbCount'), hint = $('nmsLbHint');
  var opens = [$('nmsExpand'), root.querySelector('[data-lb="motif"]')];
  if (!dlg || typeof dlg.showModal !== 'function') { opens.forEach(function (b) { if (b) b.hidden = true; }); return; }
  var items = [], idx = 0, s = 1, tx = 0, ty = 0, box = null, pts = {}, g = null, tap = { t: 0, x: 0, y: 0 }, from = null;
  var touch = !!(window.matchMedia && matchMedia('(hover: none)').matches);
  function big(u, w) { return u.replace(/([?&]width=)\d+/, '$1' + w); }
  function list() {
    var v = st.v, out = (v.photos || []).map(function (p) {
      return { s: p.s, l: big(p.l || p.s, Math.min(2400, p.w || 2400)), w: p.w, h: p.h, a: p.a };
    });
    out.push({ s: v.design.src, l: big(v.design.src, Math.min(2800, v.design.w || 2800)), w: v.design.w, h: v.design.h, a: 'Motif ' + v.code + ' en entier', motif: true });
    return out;
  }
  function fit() {
    var it = items[idx], W = view.clientWidth, H = view.clientHeight;
    var w = (it.w && it.h) ? it.w : (img.naturalWidth || W), h = (it.w && it.h) ? it.h : (img.naturalHeight || H);
    var f = Math.min(W / w, H / h);
    box = { W: W, H: H, w: w * f, h: h * f, x: (W - w * f) / 2, y: (H - h * f) / 2 };
    img.style.width = box.w + 'px'; img.style.height = box.h + 'px';
    img.style.left = box.x + 'px'; img.style.top = box.y + 'px';
  }
  // Le design zoomé ne laisse jamais de vide sur les bords ; plus petit que l'écran, il reste centré.
  function bound() {
    var sw = box.w * s, sh = box.h * s;
    tx = sw <= box.W ? (box.W - sw) / 2 - box.x : clamp(tx, box.W - sw - box.x, -box.x);
    ty = sh <= box.H ? (box.H - sh) / 2 - box.y : clamp(ty, box.H - sh - box.y, -box.y);
  }
  function apply(anim) {
    img.classList.toggle('is-anim', !!anim);
    img.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + s + ')';
    view.classList.toggle('is-zoomed', s > 1.01);
    hint.classList.toggle('is-off', s > 1.01);
  }
  function zoomAt(px, py, s2, anim) {
    var lx = (px - box.x - tx) / s, ly = (py - box.y - ty) / s;
    s = clamp(s2, 1, 4); tx = px - box.x - lx * s; ty = py - box.y - ly * s;
    bound(); apply(anim);
  }
  function show(i) {
    idx = (i + items.length) % items.length;
    var it = items[idx], my = idx;
    s = 1; tx = 0; ty = 0;
    img.src = it.s; img.alt = it.a || ('Design ' + st.v.code);
    fit(); bound(); apply(false);
    var lab = it.motif ? 'Motif ' + st.v.code + ' en entier' : it.mur ? (it.ia ? 'Rendu IA, indicatif' : it.own ? 'Votre photo' : 'Sur votre mur, aperçu indicatif') : '';
    count.textContent = (items.length > 1 ? (idx + 1) + ' / ' + items.length : '') + (lab ? (items.length > 1 ? ' · ' : '') + lab : '');
    var hi = new Image();
    hi.onload = function () { if (my === idx && dlg.open) img.src = hi.src; };
    hi.src = it.l;
  }
  img.addEventListener('load', function () { var it = items[idx]; if (it && !(it.w && it.h)) { fit(); bound(); apply(false); } });
  function open(which, e) {
    from = e && e.currentTarget;
    // Le mur : une image figée du rendu affiché, à la résolution de la photo.
    if (which === 'mur') {
      if (!mur.photo) return;
      if (IA) {
        // Le rendu affiché, sinon la photo du client, au format de la photo.
        if (!pic) return;
        var on = iaShown(), src = on ? ia.cache[iaKey()] : pic.room;
        items = [{ s: src, l: src, w: pic.w, h: pic.h, a: on ? 'Rendu indicatif du design ' + st.v.code + ' sur votre mur' : 'Votre photo', mur: true, ia: on, own: !on }];
      } else {
        if (!mur.engine) return;
        var snap = mur.engine.snapshot('image/jpeg', 0.92);
        items = [{ s: snap, l: snap, a: 'Aperçu du design ' + st.v.code + ' sur votre mur', mur: true }];
      }
    } else items = list();
    dlg.querySelectorAll('[data-lb-step]').forEach(function (b) { b.hidden = items.length < 2; });
    hint.textContent = touch ? 'Touchez deux fois ou écartez deux doigts pour zoomer' : 'Cliquez pour zoomer, molette pour ajuster';
    window.ppVerrou('visionneuse', true);
    dlg.showModal();
    if (e && e.detail !== 0) dlg.focus();
    show(which === 'motif' ? items.length - 1 : which === 'mur' ? 0 : Math.min(st.photoIdx, items.length - 1));
  }
  if (opens[0]) opens[0].addEventListener('click', function (e) { open('photo', e); });
  if (hero) hero.addEventListener('click', function (e) { open('photo', e); });
  if (opens[1]) opens[1].addEventListener('click', function (e) { open('motif', e); });
  $('nmsMurExpand').addEventListener('click', function (e) { open('mur', e); });
  dlg.addEventListener('close', function () {
    window.ppVerrou('visionneuse', false);
    pts = {}; g = null;
    // Le focus revient au bouton d'ouverture (Safari ne le rend pas seul ; la photo n'est pas focalisable).
    var back = from === hero ? opens[0] : from;
    if (back && back.focus) back.focus({ preventScroll: true });
    // La scène reprend la photo regardée en dernier.
    if (items[idx] && !items[idx].motif && !items[idx].mur && idx !== st.photoIdx) showPhoto(idx);
  });
  dlg.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lb-step], [data-lb-close]');
    if (!b) return;
    if (b.hasAttribute('data-lb-close')) dlg.close(); else show(idx + (+b.getAttribute('data-lb-step')));
  });
  dlg.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); show(idx + (e.key === 'ArrowRight' ? 1 : -1)); }
  });
  window.addEventListener('resize', function () { if (dlg.open) { fit(); bound(); apply(false); } }, { passive: true });

  function local(e) { var r = view.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; }
  view.addEventListener('pointerdown', function (e) {
    if (e.button !== undefined && e.button !== 0) return;
    try { view.setPointerCapture(e.pointerId); } catch (x) {}
    pts[e.pointerId] = local(e);
    var ids = Object.keys(pts);
    if (ids.length === 2) {
      var a = pts[ids[0]], b = pts[ids[1]];
      g = { pinch: true, d: Math.hypot(a[0] - b[0], a[1] - b[1]) || 1, mx: (a[0] + b[0]) / 2, my: (a[1] + b[1]) / 2, s: s, tx: tx, ty: ty };
    } else if (ids.length === 1) {
      g = { p: pts[ids[0]], tx: tx, ty: ty, moved: false };
    }
    apply(false);
  });
  view.addEventListener('pointermove', function (e) {
    if (!pts[e.pointerId] || !g) return;
    pts[e.pointerId] = local(e);
    var ids = Object.keys(pts);
    if (g.pinch) {
      if (ids.length < 2) return;
      var a = pts[ids[0]], b = pts[ids[1]], mx = (a[0] + b[0]) / 2, my = (a[1] + b[1]) / 2;
      var lx = (g.mx - box.x - g.tx) / g.s, ly = (g.my - box.y - g.ty) / g.s;
      s = clamp(g.s * Math.hypot(a[0] - b[0], a[1] - b[1]) / g.d, 1, 4);
      tx = mx - box.x - lx * s; ty = my - box.y - ly * s;
      bound(); apply(false);
      return;
    }
    var q = pts[e.pointerId], dx = q[0] - g.p[0], dy = q[1] - g.p[1];
    if (Math.abs(dx) + Math.abs(dy) > 6) g.moved = true;
    if (!g.moved) return;
    if (s > 1.01) { view.classList.add('is-panning'); tx = g.tx + dx; ty = g.ty + dy; bound(); apply(false); }
    else if (Math.abs(dx) >= Math.abs(dy)) img.style.transform = 'translate(' + (tx + dx) + 'px, ' + ty + 'px)';
    else img.style.transform = 'translate(' + tx + 'px, ' + (ty + Math.max(0, dy)) + 'px)';
  });
  function up(e) {
    if (!pts[e.pointerId]) return;
    var q = local(e);
    delete pts[e.pointerId];
    view.classList.remove('is-panning');
    var rest = Object.keys(pts);
    if (!g) return;
    if (g.pinch) {
      // Un doigt reste posé : il continue à déplacer le design.
      g = rest.length === 1 ? { p: pts[rest[0]], tx: tx, ty: ty, moved: true } : null;
      if (s < 1.05) { s = 1; bound(); apply(true); }
      return;
    }
    var was = g, dx = q[0] - was.p[0], dy = q[1] - was.p[1];
    g = null;
    if (e.type === 'pointercancel') { if (s <= 1.01) apply(true); return; }
    if (!was.moved) {
      if (e.pointerType === 'mouse') { zoomAt(q[0], q[1], s > 1.01 ? 1 : 2.5, true); return; }
      var now = Date.now();
      if (now - tap.t < 320 && Math.abs(q[0] - tap.x) < 40 && Math.abs(q[1] - tap.y) < 40) { tap.t = 0; zoomAt(q[0], q[1], s > 1.01 ? 1 : 2.5, true); }
      else tap = { t: now, x: q[0], y: q[1] };
      return;
    }
    if (s > 1.01) return;
    if (items.length > 1 && Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) { show(idx + (dx < 0 ? 1 : -1)); return; }
    if (dy > 110 && dy > Math.abs(dx)) { dlg.close(); return; }
    apply(true);
  }
  view.addEventListener('pointerup', up);
  view.addEventListener('pointercancel', up);
  view.addEventListener('wheel', function (e) {
    e.preventDefault();
    var q = local(e);
    // Molette en lignes ou en pages (Firefox) ramenée en pixels, et pas plafonné à 22 % par cran :
    // Ctrl + molette d'une souris zoomait x2,7 par cran, le pincement d'un pad reste aussi fin qu'avant.
    var d = e.deltaY * (e.deltaMode === 1 ? 33 : e.deltaMode === 2 ? innerHeight : 1);
    var k = Math.max(-.2, Math.min(.2, -d * (e.ctrlKey ? .01 : .0025)));
    zoomAt(q[0], q[1], s * Math.exp(k), false);
  }, { passive: false });
  // Safari iOS : pas de zoom de la page entière par-dessus.
  view.addEventListener('gesturestart', function (e) { e.preventDefault(); });
})();

/* ---------- Designs ---------- */
var strip = $('nmsStrip');
D.variants.forEach(function (v) {
  var b = document.createElement('button');
  b.type = 'button';
  b.className = 'nms__sw';
  b.setAttribute('data-vid', v.id);
  b.setAttribute('aria-label', 'Design ' + v.code + (v.ok ? '' : ' (indisponible)'));
  b.setAttribute('aria-pressed', v === st.v ? 'true' : 'false');
  var im = document.createElement('img');
  im.src = v.design.th; im.alt = ''; im.width = 120; im.height = 120;
  im.loading = 'lazy'; im.decoding = 'async';
  var sp = document.createElement('span');
  sp.textContent = v.code;
  b.appendChild(im); b.appendChild(sp);
  b.addEventListener('click', function (e) { selectVariant(v, true); if (e.detail !== 0) toStage(); });
  strip.appendChild(b);
});
function selectVariant(v, byUser) {
  if (v === st.v) return;
  st.v = v;
  strip.querySelectorAll('.nms__sw').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-vid') === v.id ? 'true' : 'false'); });
  $('nmsCode').textContent = v.code;
  try {
    var u = new URL(location.href);
    u.searchParams.set('variant', v.id);
    history.replaceState(history.state, '', u.toString());
  } catch (e) {}
  showPhoto(0);
  setCropImage(v);
  var wa = $('nmsWa');
  if (wa) wa.href = 'https://wa.me/33756808726?text=' + encodeURIComponent('Bonjour, j’ai une question sur : ' + D.title + ' (design ' + v.code + ')');
  if (byUser) compte('clic', v.code);
  if (murOn()) applyMurDesign();
  render();
}
/* Un design choisi plus bas → on remonte doucement aux images (comme la fiche classique). Le scroll
   « smooth » natif ne marche pas sur ces pages : petits pas 'instant' à chaque image. Le moindre toucher,
   coup de molette ou touche du client arrête l'animation. Ordinateur : la scène est collante, rien à faire. */
function toStage() {
  if (desk.matches && getComputedStyle(stage.parentNode).position === 'sticky') return;  // ordinateur : la scène reste à l'écran
  var haut = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--site-header-total-h'), 10) || 90;
  var top = stage.getBoundingClientRect().top;
  if (top >= haut - 4) return;
  scrollSoft(Math.max(0, top + window.pageYOffset - haut - 8));
}
function scrollSoft(y) {
  var y0 = window.pageYOffset, dy = y - y0, t0 = null, stop = false;
  if (Math.abs(dy) < 2) return;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) { window.scrollTo({ top: y, behavior: 'instant' }); return; }
  var dur = clamp(Math.abs(dy) * 0.6, 280, 650);
  function arret() { stop = true; off(); }
  function off() { ['touchstart', 'wheel', 'keydown'].forEach(function (t) { window.removeEventListener(t, arret); }); }
  ['touchstart', 'wheel', 'keydown'].forEach(function (t) { window.addEventListener(t, arret, { passive: true }); });
  function step(t) {
    if (stop) return;
    if (t0 === null) t0 = t;
    var k = Math.min(1, (t - t0) / dur), e = k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
    window.scrollTo({ top: Math.round(y0 + dy * e), behavior: 'instant' });
    if (k < 1) requestAnimationFrame(step); else off();
  }
  requestAnimationFrame(step);
}
function setCropImage(v) {
  cropImg.src = v.design.src;
  designImg(v).then(function (img) {
    v.design.nw = img.naturalWidth; v.design.nh = img.naturalHeight;
    if (v === st.v) render();
  }, function () {});
}

/* ---------- Vues ---------- */
var tabs = root.querySelectorAll('.nms__tab');
function setView(view) {
  st.view = view;
  if (view === 'mur') moveMur('stage');
  stage.setAttribute('data-view', view);
  tabs.forEach(function (t) {
    var on = t.getAttribute('data-view') === view;
    t.setAttribute('aria-selected', on ? 'true' : 'false');
    t.tabIndex = on ? 0 : -1;
  });
  $('nmsViewPhoto').hidden = view !== 'photo';
  $('nmsViewMur').hidden = view !== 'mur';
  murUi();
  if (view === 'mur') openMur();
  render();
  if (view === 'photo') thumbsReveal();
}
tabs.forEach(function (t, i) {
  t.addEventListener('click', function () { setView(t.getAttribute('data-view')); });
  t.addEventListener('keydown', function (e) {
    var j = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : -1;
    if (j < 0 && e.key !== 'ArrowLeft') return;
    e.preventDefault();
    var n = tabs[(j + tabs.length) % tabs.length];
    n.focus(); n.click();
  });
});
root.querySelectorAll('[data-photo-step]').forEach(function (b) {
  b.addEventListener('click', function () { showPhoto(st.photoIdx + (+b.getAttribute('data-photo-step'))); });
});
root.addEventListener('click', function (e) {
  var g = e.target.closest && e.target.closest('[data-go-view]');
  if (g) setView(g.getAttribute('data-go-view'));
});

/* ---------- « Sur mon mur » ---------- */
var mur = { engine: null, loading: null, photo: false, shown: null, gated: false, editing: false, busy: false, detected: false, where: 'stage', want: null };
// Avec l'IA : la photo du client préparée pour le rendu ({ room, w, h, ratio }), sans moteur 3D.
var pic = null;

/* Une seule vue du mur, à deux places : la scène (onglet « Sur mon mur ») ou, sur téléphone, l'étape 2,
   sous le cadrage et la taille du motif. Ordinateur : la scène est collée à côté de l'étape 2, on y reste. */
var slot = $('nmsMurSlot'), murBox = $('nmsMurBox'), subMur = $('nmsSubMur');
var boxHome = murBox.parentNode, subHome = { p: subMur.parentNode, n: subMur.nextSibling };
var desk = window.matchMedia ? matchMedia('(min-width: 1101px)') : { matches: false };
/* Ordinateur : hauteur où la scène se colle = bas de l'en-tête une fois les barres du haut sorties
   de l'écran (l'en-tête se pose alors à 6 px du haut), plus un peu d'air. */
function calerHaut() {
  var h = document.getElementById('site-header');
  if (!h || !h.offsetHeight) return;
  var rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
  root.style.setProperty('--nms-top', Math.round(6 + h.offsetHeight + rem * .75) + 'px');
}
calerHaut();
window.addEventListener('resize', calerHaut, { passive: true });
window.addEventListener('load', calerHaut);
var lbOk = typeof $('nmsLb').showModal === 'function';
function murOn() { return st.view === 'mur' || mur.where === 'crop'; }
function hosts(fn) { fn(stage); fn(slot); }
function moveMur(where) {
  if (mur.where === where) return;
  mur.where = where;
  if (where === 'crop') { slot.appendChild(murBox); $('nmsTryLive').appendChild(subMur); }
  else { boxHome.appendChild(murBox); subHome.p.insertBefore(subMur, subHome.n); }
  if (mur.engine) mur.engine.layout();
}
function showMurHere() {
  if (desk.matches) { if (st.view !== 'mur') setView('mur'); return; }
  moveMur('crop');
  if (st.view === 'mur') setView('photo');
  openMur();
  updateNote();
}
function tryUi() {
  var here = mur.where === 'crop', side = desk.matches && st.view === 'mur' && (mur.photo || mur.busy);
  $('nmsTryLive').hidden = !here;
  $('nmsTryDesk').hidden = !side;
  $('nmsTryCta').hidden = here || side;
  $('nmsTryPick').hidden = mur.photo;
  $('nmsTryShow').hidden = !mur.photo;
  $('nmsTrySub').textContent = IA
    ? (mur.photo ? 'Votre photo est prête : l’IA y pose le design et le cadrage choisis.' : 'Une photo de votre mur, prise de face : l’IA y pose ce design et ce cadrage, comme sur nos photos.')
    : mur.photo ? 'Votre photo est prête : le cadrage s’y affiche en direct.'
    : 'Une photo de votre mur, prise de face : le cadrage s’y affiche en direct. Elle reste sur votre appareil.';
  $('nmsTryQuota').textContent = IA ? (quotaText() + ' La photo est envoyée à notre prestataire d’IA (Google) pour le rendu ; nous ne la conservons pas.').trim() : quotaText();
  $('nmsTryDesk').textContent = IA
    ? 'Votre mur s’affiche à gauche. Après un changement de design ou de cadrage, relancez le rendu sous la photo.'
    : 'Votre mur s’affiche à gauche : chaque réglage du cadrage s’y applique en direct.';
}
$('nmsTryShowBtn').addEventListener('click', function () {
  showMurHere();
  var t = desk.matches ? $('nmsTryDesk') : $('nmsTryLive');
  if (!t.hidden) t.focus({ preventScroll: true });
});
$('nmsTryHide').addEventListener('click', function () {
  moveMur('stage');
  murUi();
  var b = mur.photo ? $('nmsTryShowBtn') : $('nmsTryPick').querySelector('button');
  b.focus({ preventScroll: true });
});
function onDesk() {
  if (desk.matches && mur.where === 'crop') { moveMur('stage'); setView('mur'); }
  else murUi();
}
if (desk.addEventListener) desk.addEventListener('change', onDesk); else if (desk.addListener) desk.addListener(onDesk);
var GKEY = 'nms:mur', gMem = { seen: [], unlocked: false };
function gate() {
  try {
    var o = JSON.parse(localStorage.getItem(GKEY) || 'null');
    if (o && Array.isArray(o.seen)) return { seen: o.seen.slice(0, 500).map(String), unlocked: !!o.unlocked };
  } catch (e) {}
  return { seen: gMem.seen.slice(), unlocked: gMem.unlocked };
}
function saveGate(g) {
  gMem = { seen: g.seen.slice(), unlocked: g.unlocked };
  try { localStorage.setItem(GKEY, JSON.stringify(gMem)); } catch (e) {}
}
function canShow(code) { if (IA) return true; var g = gate(); return g.unlocked || g.seen.indexOf(code) >= 0 || g.seen.length < FREE; }
function markSeen(code) { var g = gate(); if (g.seen.indexOf(code) < 0) { g.seen.push(code); saveGate(g); } }
function quotaText() {
  // Avec l'IA, chaque rendu est un essai (nmsIaQuota).
  if (IA) return iaQuota();
  var g = gate();
  if (g.unlocked) return 'Tous les designs sont débloqués sur votre mur.';
  var left = Math.max(0, FREE - g.seen.length);
  if (left === FREE) return FREE + ' designs à essayer gratuitement sur votre mur.';
  if (left > 0) return 'Designs essayés sur votre mur : ' + g.seen.length + ' sur ' + FREE + ' offerts.';
  return 'Vos ' + FREE + ' designs offerts sont essayés. Ceux déjà vus restent disponibles.';
}
function murUi() {
  var onMur = murOn();
  hosts(function (h) {
    h.classList.toggle('has-photo', mur.photo || mur.busy);
    h.classList.toggle('is-gated', mur.gated);
  });
  $('nmsSubMur').hidden = !(onMur && mur.photo && !mur.gated && !mur.busy);
  $('nmsMurExpand').hidden = !(lbOk && mur.photo && !mur.gated && !mur.busy && !mur.editing);
  tryUi();
  $('nmsMurQuota').textContent = quotaText();
  if (IA) { var dv = dims().valid; $('nmsMurPickBtns').hidden = !dv; $('nmsMurNeedDims').hidden = dv; }
  $('nmsMurCorners').setAttribute('aria-pressed', mur.editing ? 'true' : 'false');
  $('nmsMurBefore').setAttribute('aria-pressed', st.before ? 'true' : 'false');
  iaUi();
  murInfo();
}
function murInfo() {
  var info = $('nmsMurInfo');
  if (mur.editing) info.textContent = 'Glissez les 4 points blancs sur les coins de votre mur.';
  else if (IA) info.textContent = !mur.photo || mur.busy || ia.busy ? ''
    : iaShown() ? 'Rendu indicatif par l’IA. Nous imprimons le design lui-même, pas ce rendu : à la commande, aux dimensions exactes de votre mur et avec ce cadrage. Un défaut d’impression ? Réimpression sans frais.'
    : ia.order.length && dims().valid && !ia.cache[iaKey()] ? 'Le design, le cadrage ou les mesures ont changé : relancez le rendu pour les voir sur votre mur.' : '';
  else if (mur.photo) info.textContent = ((mur.detected ? 'Glissez sur la photo pour décaler le motif. ' : '') + (IA ? '' : quotaText())).trim();
  else info.textContent = '';
  info.hidden = !info.textContent;
}
function card(which) {
  ['nmsMurIntro', 'nmsMurFail', 'nmsGate'].forEach(function (id) { $(id).hidden = id !== which; });
}
function ensureMurJs() {
  if (window.NovomurMur) return Promise.resolve();
  if (mur.loading) return mur.loading;
  mur.loading = new Promise(function (res, rej) {
    var s = document.createElement('script');
    s.src = D.murJs; s.async = true;
    s.onload = function () { window.NovomurMur ? res() : rej(new Error('js')); };
    s.onerror = function () { s.remove(); rej(new Error('js')); };
    document.head.appendChild(s);
  });
  mur.loading.catch(function () { mur.loading = null; });
  return mur.loading;
}
function openMur() {
  murUi();
  if (mur.busy) return;
  if (mur.photo) { applyMurDesign(); return; }
  if (IA) { card('nmsMurIntro'); return; }
  if ($('nmsMurFail').hidden || $('nmsMurFail').getAttribute('data-kind') !== 'webgl') card('nmsMurIntro');
  ensureMurJs().then(function () {
    if (!window.NovomurMur.supported()) { murFail('webgl'); return; }
    // Le modèle (≈ 4 Mo, mis en cache) se charge pendant que le client prend sa photo.
    window.NovomurMur.preload().catch(function () {});
  }, function () {});
}
var FAILS = {
  webgl: ['Aperçu indisponible sur cet appareil', 'Votre navigateur ne permet pas cet aperçu. Envoyez-nous la photo de votre mur sur WhatsApp : nous vous répondons avec un aperçu.'],
  net: ['Aperçu momentanément indisponible', "L'outil n'a pas pu se charger. Vérifiez votre connexion puis réessayez."],
  format: ["Cette photo n'a pas pu être lue", 'Choisissez une photo au format JPG ou PNG. Sur iPhone, une capture d’écran de la photo fonctionne aussi.']
};
function murFail(kind) {
  mur.busy = false;
  $('nmsMurBusy').hidden = true;
  var f = FAILS[kind] || FAILS.net, el = $('nmsMurFail');
  el.setAttribute('data-kind', kind);
  $('nmsMurFailTitle').textContent = f[0];
  $('nmsMurFailText').textContent = f[1];
  $('nmsMurRetry').hidden = kind === 'webgl';
  $('nmsMurRetry').textContent = kind === 'net' ? 'Réessayer avec une photo' : 'Choisir une autre photo';
  // Sans aperçu possible sur l'appareil, WhatsApp devient l'action principale.
  $('nmsMurWa').classList.toggle('nms__btn--dark', kind === 'webgl');
  $('nmsMurWa').classList.toggle('nms__btn--line', kind !== 'webgl');
  hosts(function (h) { h.classList.remove('is-loading'); });
  if (!mur.photo) { hosts(function (h) { h.classList.remove('has-photo'); }); card('nmsMurFail'); }
  else { card(null); showToast(f[0] + '.'); }
  murUi();
}
function progress(step, frac) {
  var t = $('nmsMurBusyText'), bar = $('nmsMurBar');
  if (step === 'model') { t.textContent = "Préparation de l'outil… " + Math.round((frac || 0) * 100) + ' %'; bar.style.transform = 'scaleX(' + (0.08 + 0.62 * (frac || 0)) + ')'; }
  else if (step === 'detect') { t.textContent = 'Repérage de votre mur…'; bar.style.transform = 'scaleX(.78)'; }
  else if (step === 'refine') { t.textContent = 'Pose du papier peint…'; bar.style.transform = 'scaleX(.92)'; }
}
async function onFile(file) {
  if (!file || mur.busy) return;
  if (IA) { picFile(file); return; }
  var want = mur.want;
  mur.want = null;
  // Photo demandée depuis l'étape 2 : le mur s'affiche là où le client l'a demandé.
  if (want === 'crop') showMurHere();
  if (file.type && !/^image\//.test(file.type)) { murFail('format'); return; }
  iaNewPhoto();
  // La progression s'affiche tout de suite, même pendant le chargement de l'outil.
  mur.busy = true;
  card(null);
  $('nmsMurBusy').hidden = false;
  progress('model', 0);
  $('nmsMurBusyText').textContent = 'Préparation…';
  hosts(function (h) { h.classList.add('has-photo', 'is-loading'); });
  murUi();
  try { await ensureMurJs(); } catch (e) { murFail('net'); return; }
  if (!window.NovomurMur.supported()) { murFail('webgl'); return; }
  var url = URL.createObjectURL(file), probe;
  try { probe = await loadImg(url); } catch (e) { URL.revokeObjectURL(url); murFail('format'); return; }
  hosts(function (h) { h.style.setProperty('--nms-mur-ar', clamp(probe.naturalWidth / probe.naturalHeight, 0.75, 1.78).toFixed(4)); });
  try {
    if (!mur.engine) {
      mur.engine = window.NovomurMur.create($('nmsMurEngine'));
      mur.engine.onCornersChange(function () { compteMur(); });
    }
    var r = await mur.engine.setPhoto(url, progress);
    mur.photo = true;
    mur.detected = r.detected;
    mur.shown = null;
    st.before = false;
    mur.engine.showOriginal(false);
    setEditing(!r.detected);
  } catch (e) {
    URL.revokeObjectURL(url);
    murFail(/webgl/i.test(String(e && e.message)) ? 'webgl' : 'format');
    return;
  }
  URL.revokeObjectURL(url);
  mur.busy = false;
  hosts(function (h) { h.classList.remove('is-loading'); });
  $('nmsMurBusy').hidden = true;
  applyMurDesign();
  if (!mur.detected && !mur.gated) showToast("Nous n'avons pas trouvé votre mur avec certitude : placez les 4 points sur ses coins.");
}
function compteMur() { murUi(); }
function applyMurDesign() {
  if (!mur.photo || !mur.engine || mur.busy) { murUi(); return; }
  var v = st.v;
  if (!canShow(v.code)) {
    mur.gated = true;
    $('nmsGateTitle').textContent = 'Essayez le design ' + v.code + ' sur votre mur';
    root.querySelectorAll('[data-free]').forEach(function (s) { s.textContent = String(FREE); });
    card('nmsGate');
    murUi();
    updateNote();
    return;
  }
  mur.gated = false;
  card(null);
  designImg(v).then(function (img) {
    if (st.v !== v || mur.gated || !mur.engine) return;
    markSeen(v.code);
    if (mur.shown !== v.code) { mur.engine.setDesign(img); mur.shown = v.code; }
    mur.engine.setCrop(engineCrop(frame(v)));
    murUi();
    updateNote();
  }, function () { showToast('Le design ne s’est pas chargé : vérifiez votre connexion.'); });
  murUi();
}
function setEditing(on) {
  mur.editing = !!on;
  if (mur.engine) mur.engine.setEditing(mur.editing);
  hosts(function (h) { h.classList.toggle('is-editing', mur.editing); });
  murUi();
}
root.querySelectorAll('[data-pick]').forEach(function (b) {
  b.addEventListener('click', function () {
    var inp = $(b.getAttribute('data-pick'));
    if (inp && !mur.busy) { mur.want = b.getAttribute('data-place'); inp.value = ''; inp.click(); }
  });
});
['nmsFileCam', 'nmsFilePick'].forEach(function (id) {
  $(id).addEventListener('change', function () { var f = this.files && this.files[0]; if (f) onFile(f); });
});
$('nmsMurCorners').addEventListener('click', function () { setEditing(!mur.editing); });
$('nmsMurBefore').addEventListener('click', function () {
  st.before = !st.before;
  if (mur.engine) mur.engine.showOriginal(st.before);
  murUi();
});

/* Déblocage : au-delà des designs offerts, le numéro du client (formulaire de contact Shopify,
   comme le rappel de la fiche classique). L'équipe le recontacte pour finaliser. */
function normTel(raw) {
  var s = String(raw || '').replace(/[\s.\-()\/]/g, '');
  if (/^0[1-9]\d{8}$/.test(s)) return '+33' + s.slice(1);
  if (/^0033[1-9]\d{8}$/.test(s)) return '+33' + s.slice(4);
  if (/^\+33[1-9]\d{8}$/.test(s)) return s;
  if (/^\+[1-9]\d{7,14}$/.test(s) && s.indexOf('+33') !== 0) return s;
  return null;
}
$('nmsGate').addEventListener('submit', async function (e) {
  e.preventDefault();
  var tel = $('nmsGateTel'), err = $('nmsGateErr'), btn = $('nmsGateBtn');
  var n = normTel(tel.value);
  if (!n) {
    err.textContent = 'Saisissez un numéro valide, par exemple 06 12 34 56 78.';
    err.hidden = false;
    tel.setAttribute('aria-invalid', 'true');
    tel.focus();
    return;
  }
  err.hidden = true;
  tel.setAttribute('aria-invalid', 'false');
  btn.disabled = true;
  btn.textContent = 'Envoi…';
  var d = dims(), g = gate();
  var body = [
    'Studio « Sur mon mur » : déblocage des designs',
    'Produit : ' + D.title + ' (' + location.origin + '/products/' + D.handle + '?variant=' + st.v.id + ')',
    'Design demandé : ' + st.v.code,
    'Mesures : ' + (d.valid ? d.w + ' × ' + d.h + ' cm' : 'non saisies'),
    'Finition : ' + st.mat,
    'Designs déjà essayés : ' + (g.seen.join(', ') || 'aucun'),
    'Téléphone : ' + n
  ].join('\n');
  var fd = new FormData();
  fd.append('form_type', 'contact');
  fd.append('utf8', '✓');
  fd.append('contact[email]', n.replace(/\D/g, '') + '@callback.novomur.com');
  fd.append('contact[phone]', n);
  fd.append('contact[body]', body);
  try {
    var res = await fetch('/contact', { method: 'POST', body: fd });
    if (res.status >= 500) throw new Error('contact');
  } catch (x) {
    btn.disabled = false;
    btn.textContent = 'Continuer';
    err.textContent = "L'envoi n'a pas abouti. Vérifiez votre connexion et réessayez.";
    err.hidden = false;
    return;
  }
  g.unlocked = true;
  saveGate(g);
  btn.disabled = false;
  btn.textContent = 'Continuer';
  tel.value = '';
  applyMurDesign();
  showToast('Merci ! Tous les designs sont débloqués sur votre mur.');
});

/* ---------- Rendu par l'IA (worker novomur-studio) ----------
   La photo du client est d'abord ramenée au format d'image le plus proche que l'IA sait rendre (recadrage
   centré minimal), puis affichée telle quelle. Au rendu, elle part au worker avec le design cadré au format
   du mur, les mesures et une photo Novomur du même design posé : l'IA pose le design comme sur nos photos,
   sans zoom ni recadrage. Le rendu revient au format exact de la photo affichée.
   1 rendu = 1 essai : IA_FREE offerts par appareil, puis un code par e-mail (rendus suivants non affichés au
   client), puis un conseiller prend le relais. Un rendu raté n'est pas décompté (le worker le rend). */
var ia = {
  busy: false, timer: 0, photo: 0, after: false,
  cache: {}, order: [], refs: {},
  mail: '', tel: null, waitT: 0, mem: null, dev: null
};
var IKEY = 'nms:ia';
function iaGet() {
  var o = null;
  try { o = JSON.parse(localStorage.getItem(IKEY) || 'null'); } catch (e) {}
  if (!o || typeof o !== 'object') o = ia.mem || {};
  return { n: Math.max(0, +o.n || 0), token: typeof o.token === 'string' ? o.token : '', email: typeof o.email === 'string' ? o.email : '', contact: !!o.contact };
}
function iaSave(s) {
  ia.mem = s;
  try { localStorage.setItem(IKEY, JSON.stringify(s)); } catch (e) {}
}
// Identifiant aléatoire de l'appareil : compte les rendus offerts côté worker (aucune donnée personnelle).
function iaDevice() {
  if (ia.dev) return ia.dev;
  var d = null;
  try { d = localStorage.getItem('nms:dev'); } catch (e) {}
  if (!d || !/^[A-Za-z0-9_-]{16,64}$/.test(d)) {
    var a = new Uint8Array(18);
    try { crypto.getRandomValues(a); } catch (e) { for (var i = 0; i < a.length; i++) a[i] = Math.floor(Math.random() * 256); }
    d = btoa(String.fromCharCode.apply(null, a)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    try { localStorage.setItem('nms:dev', d); } catch (e) {}
  }
  return (ia.dev = d);
}
// Corps en text/plain : pas de requête préalable (OPTIONS), le worker lit le JSON quel que soit le type.
async function iaPost(path, body, ms) {
  var ctl = window.AbortController ? new AbortController() : null;
  var to = setTimeout(function () { if (ctl) ctl.abort(); }, ms || 20000);
  try {
    var r = await fetch(IA + path, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(body), signal: ctl ? ctl.signal : undefined });
    var j = null;
    try { j = await r.json(); } catch (e) {}
    return j && typeof j === 'object' ? j : { error: r.ok ? 'FAIL' : (r.status === 429 ? 'LIMIT' : 'FAIL') };
  } catch (e) {
    return { error: 'NET' };
  } finally { clearTimeout(to); }
}
// Formats d'image que l'IA sait rendre (le worker choisit le plus proche du ratio envoyé).
var IA_RATIOS = [[1, 1], [2, 3], [3, 2], [3, 4], [4, 3], [4, 5], [5, 4], [9, 16], [16, 9], [21, 9]];
function canvasOf(w, h) {
  var c = document.createElement('canvas');
  c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h));
  return c;
}
/* La photo du client, au format le plus proche que l'IA sait rendre : ainsi le rendu revient au même
   cadrage, sans bandes ni zoom. Une photo de téléphone (4:3, 3:4, 16:9) n'est pas recadrée. */
async function preparePhoto(file) {
  var url = URL.createObjectURL(file), img;
  try { img = await loadImg(url); } finally { URL.revokeObjectURL(url); }
  var iw = img.naturalWidth, ih = img.naturalHeight;
  if (!iw || !ih) throw new Error('image');
  var r = iw / ih, best = IA_RATIOS[0], bd = Infinity;
  IA_RATIOS.forEach(function (q) { var d = Math.abs(Math.log(r * q[1] / q[0])); if (d < bd) { bd = d; best = q; } });
  var t = best[0] / best[1], sw = iw, sh = ih;
  if (r > t) sw = ih * t; else sh = iw / t;
  var k = Math.min(1, 1600 / Math.max(sw, sh)), c = canvasOf(sw * k, sh * k);
  c.getContext('2d').drawImage(img, (iw - sw) / 2, (ih - sh) / 2, sw, sh, 0, 0, c.width, c.height);
  var room = c.toDataURL('image/jpeg', 0.86);
  if (room.length > 2400000) room = c.toDataURL('image/jpeg', 0.7);
  return { room: room, w: c.width, h: c.height, ratio: +t.toFixed(4) };
}
// Une photo Novomur du design posé (la première de l'annonce) : l'IA y voit comment le design se pose.
function iaRef(v) {
  var p = v.photos && v.photos[0];
  if (!p || !p.s) return Promise.resolve('');
  if (!ia.refs[v.code]) {
    ia.refs[v.code] = loadImg(p.s).then(function (img) {
      var k = Math.min(1, 1024 / Math.max(img.naturalWidth, img.naturalHeight)), c = canvasOf(img.naturalWidth * k, img.naturalHeight * k);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      return c.toDataURL('image/jpeg', 0.85);
    }).catch(function () { delete ia.refs[v.code]; return ''; });
  }
  return ia.refs[v.code];
}
// Le rendu ramené au format exact de la photo affichée (l'IA rend à quelques % près).
async function iaFit(src, w, h) {
  try {
    var img = await loadImg(src), iw = img.naturalWidth, ih = img.naturalHeight, sx = 0, sy = 0, sw = iw, sh = ih;
    var d = Math.log((iw / ih) / (w / h));
    // Écart nettement plus grand qu'attendu : on recadre au centre plutôt que de déformer.
    if (d > 0.05) { sw = ih * w / h; sx = (iw - sw) / 2; } else if (d < -0.05) { sh = iw * h / w; sy = (ih - sh) / 2; }
    var c = canvasOf(w, h);
    c.getContext('2d').drawImage(img, sx, sy, sw, sh, 0, 0, w, h);
    var b = await new Promise(function (res) { c.toBlob(res, 'image/jpeg', 0.92); });
    if (b) return URL.createObjectURL(b);
  } catch (e) {}
  return iaBlobUrl(src);
}
// Un rendu correspond à une photo, un design, un cadrage et des mesures (saisies : pas de mur indicatif).
function iaKey() {
  var e = effDims();
  if (!mur.photo || !pic || !e.real) return '';
  var r3 = function (n) { return Math.round(n * 1000); };
  return [ia.photo, st.v.code, engineCrop(frame(st.v)).map(r3).join(','), e.w + 'x' + e.h].join('|');
}
function iaShown() {
  return !!(IA && mur.photo && !mur.busy && !st.before && ia.cache[iaKey()]);
}
function iaQuota() {
  var s = iaGet();
  if (s.contact) return 'Un conseiller va vous recontacter pour finaliser votre papier peint.';
  if (s.token) return '';
  if (s.n <= 0) return IA_FREE + ' rendus offerts.';
  if (s.n < IA_FREE) return 'Rendus offerts utilisés : ' + s.n + ' sur ' + IA_FREE + '.';
  return 'Vos ' + IA_FREE + ' rendus offerts sont utilisés : un code reçu par e-mail permet de continuer.';
}
function iaUi() {
  if (!IA) return;
  var k = iaKey(), has = !!(k && ia.cache[k]), shown = iaShown(), out = $('nmsMurRender'), tag = $('nmsMurTag');
  if (shown && out.getAttribute('src') !== ia.cache[k]) out.src = ia.cache[k];
  out.hidden = !shown;
  out.alt = shown ? 'Rendu indicatif du design ' + st.v.code + ' sur votre mur' : '';
  $('nmsMurPic').hidden = !mur.photo;
  tag.hidden = !mur.photo || mur.busy;
  tag.textContent = shown ? 'Rendu IA, indicatif' : 'Votre photo';
  hosts(function (h) { h.classList.toggle('is-ia', shown); });
  $('nmsIa').hidden = !(mur.photo && !mur.busy && !has);
  $('nmsIaBtn').disabled = ia.busy;
  $('nmsIaBtnText').textContent = dims().valid ? 'Voir le design ' + st.v.code + ' sur mon mur' : 'Saisir mes mesures';
  $('nmsMurCorners').hidden = true;
  $('nmsMurBefore').hidden = !has;
  var q = iaQuota();
  $('nmsIaQuota').textContent = q;
  $('nmsIaQuota').hidden = !q;
}
function iaPut(key, url) {
  if (ia.cache[key] && ia.cache[key] !== url && ia.cache[key].indexOf('blob:') === 0) URL.revokeObjectURL(ia.cache[key]);
  ia.cache[key] = url;
  ia.order = ia.order.filter(function (k) { return k !== key; });
  ia.order.push(key);
  while (ia.order.length > 12) {
    var old = ia.order.shift();
    if (ia.cache[old] && ia.cache[old].indexOf('blob:') === 0) URL.revokeObjectURL(ia.cache[old]);
    delete ia.cache[old];
  }
}
function iaBlobUrl(d) {
  try {
    var i = d.indexOf(','), mime = d.slice(5, d.indexOf(';')), bin = atob(d.slice(i + 1)), n = bin.length, u = new Uint8Array(n);
    for (var k = 0; k < n; k++) u[k] = bin.charCodeAt(k);
    return URL.createObjectURL(new Blob([u], { type: mime }));
  } catch (e) { return d; }
}
// Pendant le rendu (5 à 15 s) : progression sur la vue du mur ; design, mesures et cadrage figés.
var IA_STEPS = [[0, 'L’IA pose le design sur votre mur…'], [4500, 'Lumière et ombres de votre pièce…'], [10000, 'Encore quelques secondes…']];
function iaLock(on) {
  ia.busy = on;
  clearInterval(ia.timer);
  root.classList.toggle('is-ia-busy', on);
  ['nmsDesigns', 'nmsStepDims', 'nmsCrop', 'nmsCropTools'].forEach(function (id) { var el = $(id); if (el) el.inert = on; });
  subMur.querySelectorAll('.nms__chip').forEach(function (b) { b.disabled = on; });
  if (mur.busy) return; // une nouvelle photo se prépare : la progression est la sienne
  var box = $('nmsMurBusy'), t = $('nmsMurBusyText'), bar = $('nmsMurBar');
  box.hidden = !on;
  $('nmsMurBusyNote').hidden = !on;
  if (!on) return;
  var t0 = Date.now(), last = '';
  function tick() {
    var ms = Date.now() - t0, txt = IA_STEPS[0][1];
    IA_STEPS.forEach(function (s) { if (ms >= s[0]) txt = s[1]; });
    if (txt !== last) { t.textContent = txt; last = txt; }
    bar.style.transform = 'scaleX(' + (0.06 + 0.86 * (1 - Math.exp(-ms / 6000))).toFixed(3) + ')';
  }
  tick();
  ia.timer = setInterval(tick, 250);
}
function iaNewPhoto() {
  if (!IA) return;
  ia.photo++;
  if (ia.busy) iaLock(false);
  ia.order.forEach(function (k) { if (ia.cache[k] && ia.cache[k].indexOf('blob:') === 0) URL.revokeObjectURL(ia.cache[k]); });
  ia.cache = {}; ia.order = [];
}
// Photo choisie : préparée, affichée, puis rendue tout de suite si les mesures sont saisies.
async function picFile(file) {
  var want = mur.want;
  mur.want = null;
  if (want === 'crop') showMurHere();
  if (file.type && !/^image\//.test(file.type)) { murFail('format'); return; }
  iaNewPhoto();
  mur.busy = true;
  card(null);
  $('nmsMurBusy').hidden = false;
  $('nmsMurBusyNote').hidden = true;
  $('nmsMurBusyText').textContent = 'Préparation de votre photo…';
  $('nmsMurBar').style.transform = 'scaleX(.4)';
  hosts(function (h) { h.classList.add('has-photo', 'is-loading'); });
  murUi();
  var p;
  try { p = await preparePhoto(file); } catch (e) { murFail('format'); return; }
  pic = p;
  $('nmsMurPhoto').src = p.room;
  $('nmsMurPhoto').alt = 'Votre mur';
  hosts(function (h) { h.style.setProperty('--nms-mur-ar', clamp(p.w / p.h, 0.5625, 1.78).toFixed(4)); h.classList.remove('is-loading'); });
  mur.photo = true;
  mur.busy = false;
  st.before = false;
  $('nmsMurBusy').hidden = true;
  murUi();
  updateNote();
  if (dims().valid) iaGo();
}
function iaGo() {
  if (ia.busy || !mur.photo || mur.busy) return;
  if (!dims().valid) { var bad = showDimsErr(true) || wIn; goTo(bad); if (bad.select) bad.select(); return; }
  var s = iaGet();
  if (s.contact) { iaGate('human'); return; }
  if (!s.token && s.n >= IA_FREE) { ia.after = true; iaGate('mail'); return; }
  iaRun();
}
var IA_ERR = {
  BUSY: 'L’IA est très demandée en ce moment : réessayez dans quelques minutes. Ce rendu n’a pas été décompté.',
  FAIL: 'Le rendu n’a pas abouti. Réessayez : il n’a pas été décompté.',
  LIMIT: 'Trop de demandes rapprochées : patientez une minute.',
  BAD: 'Cette photo n’a pas pu être envoyée. Essayez avec une autre photo de votre mur.',
  NET: 'Le rendu est momentanément indisponible. Vérifiez votre connexion et réessayez.'
};
async function iaRun() {
  var v = st.v, key = iaKey(), photo = ia.photo, p = pic, e = effDims(), art, ref;
  if (!key || !p || !e.real || ia.busy) { murUi(); return; }
  iaLock(true);
  murUi();
  try { art = cropPreview(await designImg(v), frame(v)); }
  catch (x) { iaLock(false); murUi(); showToast('Le design ne s’est pas chargé : vérifiez votre connexion.'); return; }
  ref = await iaRef(v);
  if (photo !== ia.photo) return; // une autre photo a été choisie entre-temps
  var s = iaGet();
  var r = await iaPost('/render', { device: iaDevice(), room: p.room, ref: ref || undefined, art: art, wall: { w: e.w, h: e.h }, ratio: p.ratio, token: s.token || undefined }, 75000);
  if (photo !== ia.photo) return;
  var url = r.image ? await iaFit(r.image, p.w, p.h) : '';
  if (photo !== ia.photo) { if (url.indexOf('blob:') === 0) URL.revokeObjectURL(url); return; }
  iaLock(false);
  s = iaGet();
  if (url) {
    if (typeof r.used === 'number' && !s.token) { s.n = r.used; iaSave(s); }
    iaPut(key, url);
    st.before = false;
    if (iaKey() !== key) showToast('Le réglage a changé pendant le rendu : relancez le rendu pour ce nouveau réglage.');
    murUi();
    return;
  }
  var err = r.error;
  if (err === 'TOKEN') {
    // Code expiré ou invalide : on repasse en anonyme (rendus offerts restants), sinon nouveau code.
    s.token = ''; iaSave(s); murUi();
    if (s.n < IA_FREE) { iaRun(); return; }
    ia.after = true; iaGate('mail'); return;
  }
  if (err === 'VERIFY') { s.n = Math.max(s.n, IA_FREE); iaSave(s); murUi(); ia.after = true; iaGate('mail'); return; }
  if (err === 'CONTACT') { s.contact = true; iaSave(s); murUi(); iaGate('human'); return; }
  murUi();
  showToast(IA_ERR[err] || (err === 'ORIGIN' ? IA_ERR.NET : IA_ERR.FAIL));
}
if (IA) {
  root.classList.add('is-iamode');
  $('nmsIaBtn').addEventListener('click', iaGo);
  $('nmsMurDimsBtn').addEventListener('click', function () { var bad = showDimsErr(true) || wIn; goTo(bad); if (bad.select) bad.select(); });
}

/* Code par e-mail (au-delà des rendus offerts) et relais conseiller, dans une fenêtre. */
var iaGateOpen = null;
function iaGate(name) { if (iaGateOpen) iaGateOpen(name); }
(function () {
  var dlg = $('nmsIaGate');
  if (!IA || !dlg) return;
  var fMail = $('nmsIagMail'), fCode = $('nmsIagCode'), human = $('nmsIagHuman');
  var email = $('nmsIagEmail'), tel = $('nmsIagTel'), mailErr = $('nmsIagMailErr'), send = $('nmsIagSend');
  var codeIn = $('nmsIagCodeIn'), codeErr = $('nmsIagCodeErr'), check = $('nmsIagCheck'), resend = $('nmsIagResend');
  var news = $('nmsIagNews');
  var TITLES = { mail: 'Continuez vos rendus réalistes', code: 'Saisissez votre code', human: 'Un conseiller prend le relais' };
  var STEPS = { mail: fMail, code: fCode, human: human };
  dlg.querySelectorAll('[data-ia-free]').forEach(function (s) { s.textContent = String(IA_FREE); });
  function say(el, input, text) {
    el.textContent = text || '';
    el.hidden = !text;
    [email, tel, codeIn].forEach(function (i) { if (i !== input) i.removeAttribute('aria-invalid'); });
    if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
  }
  function step(name) {
    Object.keys(STEPS).forEach(function (k) { STEPS[k].hidden = k !== name; });
    $('nmsIagTitle').textContent = TITLES[name];
    say(mailErr); say(codeErr);
    if (name === 'human') {
      var wa = $('nmsIagWa');
      wa.href = 'https://wa.me/33756808726?text=' + encodeURIComponent('Bonjour, je finalise mon papier peint ' + D.title + ' (design ' + st.v.code + ') dans le Studio.');
    }
  }
  iaGateOpen = function (name) {
    if (typeof dlg.showModal !== 'function') { if (name === 'human') showToast(iaQuota()); else showToast('Écrivez-nous sur WhatsApp pour continuer vos rendus réalistes.'); return; }
    step(name);
    if (name === 'mail') { var s = iaGet(); if (!email.value && s.email) email.value = s.email; }
    if (!dlg.open) { window.ppVerrou('ia', true); dlg.showModal(); }
    dlg.focus();
  };
  dlg.addEventListener('close', function () {
    window.ppVerrou('ia', false);
    ia.after = false;
    clearInterval(ia.waitT);
    var b = $('nmsIaBtn');
    if (b && !b.hidden && !$('nmsIa').hidden) b.focus({ preventScroll: true });
  });
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || (e.target.closest && e.target.closest('[data-iag-close]'))) dlg.close();
  });
  function busyBtn(b, on, label) { b.disabled = on; b.textContent = label; }
  // « Renvoyer le code » : actif après le délai du worker (30 s).
  function countdown(sec) {
    clearInterval(ia.waitT);
    var end = Date.now() + Math.max(1, sec || 30) * 1000;
    function tick() {
      var left = Math.ceil((end - Date.now()) / 1000);
      resend.disabled = left > 0;
      resend.textContent = left > 0 ? 'Renvoyer le code (' + left + ' s)' : 'Renvoyer le code';
      if (left <= 0) clearInterval(ia.waitT);
    }
    tick();
    ia.waitT = setInterval(tick, 1000);
  }
  var START_ERR = {
    EMAIL: 'Cette adresse e-mail n’est pas valide.',
    MAIL: 'L’e-mail n’a pas pu être envoyé. Réessayez dans un instant, ou écrivez-nous sur WhatsApp.',
    LIMIT: 'Trop de demandes rapprochées : patientez une minute.',
    WAIT: 'Trop de codes demandés pour le moment. Réessayez plus tard, ou écrivez-nous sur WhatsApp.',
    NET: 'L’envoi n’a pas abouti. Vérifiez votre connexion et réessayez.'
  };
  async function start(again) {
    var r = await iaPost('/verify/start', { email: ia.mail });
    if (r.ok) { countdown(r.wait); return true; }
    // Un code vient déjà d'être envoyé à cette adresse : on passe à la saisie.
    if (r.error === 'WAIT' && r.retry > 0 && r.retry <= 60) { countdown(r.retry); return true; }
    say(again ? codeErr : mailErr, !again && r.error === 'EMAIL' ? email : null, START_ERR[r.error] || START_ERR.NET);
    return false;
  }
  fMail.addEventListener('submit', async function (e) {
    e.preventDefault();
    var em = email.value.trim(), t = tel.value.trim(), n = null;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { say(mailErr, email, 'Saisissez une adresse e-mail valide, par exemple prenom@exemple.fr.'); return; }
    if (t) { n = normTel(t); if (!n) { say(mailErr, tel, 'Ce numéro ne semble pas valide : laissez-le vide ou saisissez par exemple 06 12 34 56 78.'); return; } }
    say(mailErr);
    ia.mail = em; ia.tel = n; ia.news = !!(news && news.checked);
    busyBtn(send, true, 'Envoi…');
    var ok = await start(false);
    busyBtn(send, false, 'Recevoir mon code');
    if (!ok) return;
    $('nmsIagTo').textContent = em;
    codeIn.value = '';
    step('code');
    codeIn.focus();
  });
  var CHECK_ERR = {
    EXPIRED: 'Ce code a expiré : demandez-en un nouveau.',
    LOCKED: 'Trop d’essais : demandez un nouveau code.',
    LIMIT: 'Trop de demandes rapprochées : patientez une minute.',
    NET: 'La vérification n’a pas abouti. Vérifiez votre connexion et réessayez.'
  };
  fCode.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (check.disabled) return;
    var code = codeIn.value.replace(/\D/g, '');
    if (code.length !== 6) { say(codeErr, codeIn, 'Le code contient 6 chiffres.'); return; }
    say(codeErr);
    busyBtn(check, true, 'Vérification…');
    var d = dims();
    // Adresse et consentement figés : « Modifier l'e-mail » reste possible pendant la vérification.
    var em = ia.mail, abo = ia.news;
    var r = await iaPost('/verify/check', {
      email: em, code: code, tel: ia.tel || undefined,
      ctx: {
        design: st.v.code + ' (' + D.title + ')',
        mesures: d.valid ? d.w + ' × ' + d.h + ' cm' : 'non saisies',
        finition: st.mat,
        page: location.origin + '/products/' + D.handle + '?variant=' + st.v.id
      }
    });
    busyBtn(check, false, 'Valider');
    if (ia.mail !== em) return;
    if (r.token) {
      var s = iaGet();
      s.token = r.token; s.email = em; s.contact = false;
      iaSave(s);
      // Case cochée : inscription une fois l'adresse prouvée par le code.
      if (abo) {
        fetch(NEWS, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: em, source: 'Studio Novomur (rendus IA)' }) })
          .then(function (x) { return x.ok ? x.json() : null; })
          .then(function (res) { if (res && res.ok === true && window.nmInscrit) window.nmInscrit(em); })
          .catch(function () {});
      }
      var go = ia.after;
      dlg.close();
      murUi();
      if (go) iaRun(); else showToast('Adresse confirmée : vos rendus sont débloqués.');
      return;
    }
    if (r.error === 'CODE') { say(codeErr, codeIn, 'Code incorrect. Il vous reste ' + r.left + ' essai' + (r.left > 1 ? 's' : '') + '.'); codeIn.select(); return; }
    if (r.error === 'EMAIL') { step('mail'); say(mailErr, email, START_ERR.EMAIL); return; }
    if (r.error === 'EXPIRED' || r.error === 'LOCKED') { clearInterval(ia.waitT); resend.disabled = false; resend.textContent = 'Renvoyer le code'; }
    say(codeErr, null, CHECK_ERR[r.error] || CHECK_ERR.NET);
  });
  // 6 chiffres saisis (ou collés, ou proposés par le clavier) : validation directe.
  codeIn.addEventListener('input', function () {
    var c = codeIn.value.replace(/\D/g, '').slice(0, 6);
    if (c !== codeIn.value) codeIn.value = c;
    if (c.length === 6 && !check.disabled) { if (fCode.requestSubmit) fCode.requestSubmit(); else check.click(); }
  });
  resend.addEventListener('click', async function () {
    resend.disabled = true;
    say(codeErr);
    if (await start(true)) { showToast('Nouveau code envoyé à ' + ia.mail + '.'); codeIn.value = ''; codeIn.focus(); }
    else resend.disabled = false;
  });
  $('nmsIagBack').addEventListener('click', function () { step('mail'); email.focus(); email.select(); });
})();

/* ---------- Ajout au panier : identique à la fiche classique ---------- */
function cropPreview(img, f, max, q) {
  var iw = img.naturalWidth, ih = img.naturalHeight;
  var sx = clamp(f.x * iw, 0, iw - 1), sy = clamp(f.y * ih, 0, ih - 1);
  var sw = clamp(f.w * iw, 1, iw - sx), sh = clamp(f.h * ih, 1, ih - sy);
  var k = Math.min(1, (max || 1200) / Math.max(sw, sh));
  var c = document.createElement('canvas');
  c.width = Math.max(1, Math.round(sw * k)); c.height = Math.max(1, Math.round(sh * k));
  var x = c.getContext('2d');
  if (f.m) { x.translate(c.width, 0); x.scale(-1, 1); }
  x.drawImage(img, sx, sy, sw, sh, 0, 0, c.width, c.height);
  return c.toDataURL('image/jpeg', q || 0.85);
}
var XHR = { 'X-Requested-With': 'XMLHttpRequest' };
/* pay = true : « Acheter maintenant ». Même ligne de panier, puis le Draft Order du panier complet
   (jamais le /checkout natif : il facturerait la variante à 29,90 € sans les mesures). */
async function addToCart(pay) {
  var d = dims();
  if (!d.valid || busy) return;
  busy = true;
  cta.disabled = true;
  buy.disabled = true;
  if (pay) {
    buy.classList.add('is-busy');
    buyText.textContent = 'Préparation du paiement…';
  } else {
    cta.textContent = 'Ajout en cours…';
  }
  cartErr.hidden = true;
  var v = st.v, f = frame(v), c = cropOf(v.code);
  var cropId = Date.now().toString(36);
  try {
    var img = await designImg(v);
    var previews = {};
    try { previews = JSON.parse(sessionStorage.getItem('novomur_crop_previews') || '{}') || {}; } catch (x) {}
    previews[cropId] = cropPreview(img, f);
    sessionStorage.setItem('novomur_crop_previews', JSON.stringify(previews));
  } catch (x) {}

  var w = d.w, h = d.h, prodW = w + MARGIN_CM, prodH = h + MARGIN_CM;
  var m2 = (prodW / 100) * (prodH / 100), total = m2 * matPrice();
  var cadre = [f.x, f.y, f.w, f.h].map(function (n) { return (clamp(n, 0, 1) * 100).toFixed(2); }).join(',');
  try {
    try {
      var prev = await fetch('/cart.js', { headers: XHR }).then(function (r) { return r.json(); });
      for (var i = 0; i < (prev.items || []).length; i++) {
        var it = prev.items[i], pr = it.properties || {};
        if (pr._mur && pr._mur === murId) {
          await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: it.key, quantity: 0 }) });
        }
      }
    } catch (x) {}
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        id: String(v.id),
        quantity: 1,
        properties: {
          'Largeur (cm)': String(w) + ' (+ 10 cm marge = ' + prodW + ')',
          'Hauteur (cm)': String(h) + ' (+ 10 cm marge = ' + prodH + ')',
          'Matière': st.mat,
          'Surface (m²)': m2.toFixed(2).replace('.', ','),
          'Prix estimé': total.toFixed(2).replace('.', ',') + ' €',
          'Recadrage X (%)': String(clamp(Math.round((f.x + f.w / 2) * 100), 0, 100)),
          'Recadrage Y (%)': String(clamp(Math.round((f.y + f.h / 2) * 100), 0, 100)),
          'Mode miroir': c.m ? 'oui' : 'non',
          '_cadre': cadre,
          '_mur': murId,
          'Design': v.code,
          '_crop_id': cropId
        }
      })
    });
    if (!res.ok) throw new Error('cart ' + res.status);
  } catch (err) {
    busy = false;
    updateBar();
    cartErr.innerHTML = '';
    cartErr.appendChild(document.createTextNode("L'ajout au panier n'a pas abouti. Vérifiez votre connexion et réessayez, ou "));
    var a = document.createElement('a');
    a.href = $('nmsWa').href; a.target = '_blank'; a.rel = 'noopener';
    a.textContent = 'écrivez-nous sur WhatsApp';
    cartErr.appendChild(a);
    cartErr.appendChild(document.createTextNode('.'));
    cartErr.hidden = false;
    showToast("L'ajout au panier n'a pas abouti. Réessayez dans un instant.");
    return;
  }
  murAjoute = true;
  compte('panier', v.code);
  var payUrl = null;
  try {
    var now = await fetch('/cart.js', { headers: XHR }).then(function (r) { return r.json(); });
    if (typeof window.ppEnsureDraftCheckout === 'function') {
      var draft = window.ppEnsureDraftCheckout(now, true);
      // 25 s au plus : au-delà, le tiroir panier prend le relais (il relance la préparation lui-même).
      if (pay) payUrl = await Promise.race([draft, new Promise(function (r) { setTimeout(function () { r(null); }, 25000); })]);
    }
  } catch (x) {}
  if (pay && payUrl) {
    buyText.textContent = 'Redirection…';
    window.location.href = payUrl;
    return;
  }
  buy.classList.remove('is-busy');
  buyText.textContent = BUY_LABEL;
  cta.textContent = 'Ajouté ✓';
  cta.classList.add('is-done');
  setTimeout(function () { if (typeof window.ppCartOpen === 'function') window.ppCartOpen(); }, 150);
  setTimeout(function () { busy = false; cta.classList.remove('is-done'); updateBar(); }, 2500);
}
function goTo(el) {
  var hd = document.getElementById('site-header');
  var off = (hd ? hd.getBoundingClientRect().bottom : 90) + 24;
  window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.pageYOffset - off), behavior: 'instant' });
  el.focus({ preventScroll: true });
}
function onBuyClick(pay) {
  var mode = ctaMode();
  if (mode === 'add') { addToCart(pay); return; }
  if (mode === 'enter' || mode === 'fix') {
    var bad = showDimsErr(true) || wIn;
    goTo(bad);
    if (bad.select) bad.select();
  }
}
cta.addEventListener('click', function () { onBuyClick(false); });
buy.addEventListener('click', function () { onBuyClick(true); });
// Retour arrière depuis le paiement (page restaurée du cache) : boutons rendus, plus de « Redirection… ».
window.addEventListener('pageshow', function (e) {
  if (!e.persisted) return;
  busy = false;
  cta.classList.remove('is-done');
  updateBar();
});
function autreMur() {
  murId = newMurId(); murNum++; murAjoute = false;
  cartErr.hidden = true;
  updateBar();
  goTo(wIn);
  wIn.select();
}
otherWall.addEventListener('click', autreMur);
window.ppAutreMur = autreMur; // lien « + Ajouter un autre mur » du tiroir panier

/* ---------- Échantillon 30 × 20 cm du design affiché ----------
   Même ligne de panier que la fiche classique (Design, Matériau, _image), mais la variante suit la
   matière choisie (avant : toujours « Intissé lisse », matière réelle en propriété seulement). */
var sampleBtn = $('nmsSample'), sampleTitle = $('nmsSampleTitle'), sampleSub = $('nmsSampleSub'), sampleThumb = $('nmsSampleImg');
var SAMPLE = D.sample && D.sample.v ? D.sample : null, SAMPLE_LABEL = sampleTitle ? sampleTitle.textContent : '';
var sampleBusy = false, sampleCode = '';
function sampleVid() { return SAMPLE ? (SAMPLE.v[st.mat] || SAMPLE.v['Intissé lisse'] || null) : null; }
function sampleImg(v, w) {
  var s = String((v.design && v.design.src) || '').split('?')[0];
  if (!s) return '';
  if (s.indexOf('//') === 0) s = 'https:' + s;
  return w ? s + '?width=' + w : s;
}
function sampleUi() {
  if (!sampleBtn || !SAMPLE) return;
  sampleBtn.hidden = !sampleVid() || !st.v.ok;
  if (sampleBusy) return;
  sampleSub.textContent = '30 × 20 cm · design ' + st.v.code + ' · ' + st.mat;
  if (sampleCode === st.v.code) return;
  sampleCode = st.v.code;
  // La vignette suit le design choisi (même miniature que la bande des designs).
  if (sampleThumb && st.v.design && st.v.design.th) { sampleThumb.removeAttribute('srcset'); sampleThumb.src = st.v.design.th; }
  // Tiroir panier : proposition d'échantillon quand on retire un mur (comme la fiche classique).
  window.ppSampleVariantId = String(SAMPLE.v['Intissé lisse'] || sampleVid());
  window.ppSampleDesign = st.v.code;
  window.ppSampleImage = sampleImg(st.v, 600);
  try {
    localStorage.setItem('novomur_sample', JSON.stringify({ vid: window.ppSampleVariantId, design: window.ppSampleDesign, image: window.ppSampleImage, exp: Date.now() + 7 * 24 * 60 * 60 * 1000 }));
  } catch (e) {}
}
async function addSample() {
  var vid = sampleVid(), v = st.v, mat = st.mat;
  if (!vid || sampleBusy || !v.ok) return;
  sampleBusy = true;
  sampleBtn.disabled = true;
  sampleBtn.classList.add('is-busy');
  sampleTitle.textContent = 'Ajout de l’échantillon…';
  try {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        id: Number(vid),
        quantity: 1,
        properties: { 'Design': v.code, 'Matériau': mat, '_image': sampleImg(v, 400), '_image_url': sampleImg(v), '_url': location.pathname + '?variant=' + v.id }
      })
    });
    if (!res.ok) throw new Error('cart ' + res.status);
  } catch (err) {
    sampleBusy = false;
    sampleBtn.disabled = false;
    sampleBtn.classList.remove('is-busy');
    sampleTitle.textContent = SAMPLE_LABEL;
    showToast("L'échantillon n'a pas pu être ajouté. Vérifiez votre connexion et réessayez.");
    return;
  }
  sampleBtn.classList.remove('is-busy');
  sampleBtn.classList.add('is-done');
  sampleTitle.textContent = 'Échantillon ajouté ✓';
  setTimeout(function () { if (typeof window.ppCartOpen === 'function') window.ppCartOpen(); }, 150);
  setTimeout(function () {
    sampleBusy = false;
    sampleBtn.disabled = false;
    sampleBtn.classList.remove('is-done');
    sampleTitle.textContent = SAMPLE_LABEL;
    sampleUi();
  }, 2500);
}
if (sampleBtn) sampleBtn.addEventListener('click', addSample);

/* ---------- « Recevoir mon projet par e-mail » (worker novomur-studio, /projet/save en mode fiche) ----------
   Le projet tel qu'affiché (design, mesures, cadrage, finition, prix estimé) et une petite image du cadrage.
   Le lien de l'e-mail (?projet=) rouvre ce projet sur cette fiche, sur n'importe quel appareil. */
var projBtn = $('nmsProjBtn'), projDlg = $('nmsProjet');
var PROJ = !!(IA && projBtn && projDlg && typeof projDlg.showModal === 'function');
function projUi() { if (projBtn) projBtn.hidden = !PROJ || !st.v.ok; }
(function () {
  if (!PROJ) return;
  var form = $('nmsProjForm'), done = $('nmsProjDone'), email = $('nmsProjEmail'), news = $('nmsProjNews');
  var err = $('nmsProjErr'), send = $('nmsProjSend'), img = $('nmsProjImg'), title = $('nmsProjTitle');
  var SEND_LABEL = send.textContent, TITLE = title.textContent, sending = false, vigP = null, ouvertures = 0;
  var ERR = {
    EMAIL: 'Cette adresse e-mail n’est pas valide.',
    LIMIT: 'Trop d’envois rapprochés : réessayez un peu plus tard.',
    MAIL: 'L’e-mail n’a pas pu partir. Réessayez dans un instant.',
    NET: 'L’envoi n’a pas abouti. Vérifiez votre connexion et réessayez.',
    FAIL: 'Votre projet n’a pas pu être enregistré. Réessayez dans un instant, ou écrivez-nous sur WhatsApp.'
  };
  function say(text, field) {
    err.textContent = text || '';
    err.hidden = !text;
    if (field) { email.setAttribute('aria-invalid', 'true'); email.focus(); } else email.removeAttribute('aria-invalid');
  }
  // Même calcul que la barre d'achat : mesures saisies + marge de pose, au prix de la finition choisie.
  function devis() {
    var d = dims(), p = matPrice(), pw = d.w + MARGIN_CM, ph = d.h + MARGIN_CM;
    return { w: d.w, h: d.h, pw: pw, ph: ph, prix: Math.round((pw / 100) * (ph / 100) * p * 100) / 100 };
  }
  // Petite image du cadrage pour l'e-mail : au plus ~290 000 caractères (limite du worker : 300 000).
  function vignette() {
    var v = st.v, f = frame(v);
    return designImg(v).then(function (im) {
      for (var side = 900; side >= 300; side = Math.round(side * 0.75)) {
        var u = cropPreview(im, f, side, 0.8);
        if (u.length <= 290000) return u;
      }
      return '';
    }).catch(function () { return ''; });
  }
  function lienPage() {
    var t = window.Shopify && window.Shopify.theme, u = location.origin + location.pathname;
    return t && t.id && t.role && t.role !== 'main' ? u + '?preview_theme_id=' + t.id : u;
  }
  function open(e) {
    var q = devis();
    ouvertures++;
    form.hidden = false; done.hidden = true;
    title.textContent = TITLE;
    say('');
    if (!email.value) { var s = iaGet(); if (s.email) email.value = s.email; }
    $('nmsProjName').textContent = D.title + ', design ' + st.v.code;
    $('nmsProjDims').textContent = 'Mur de ' + fmtCm(q.w) + ' × ' + fmtCm(q.h) + ' cm · ' + st.mat;
    $('nmsProjPrice').textContent = 'Prix estimé : ' + eur(q.prix);
    img.removeAttribute('src'); img.hidden = false;
    vigP = vignette();
    vigP.then(function (u) { if (u) img.src = u; else img.hidden = true; });
    window.ppVerrou('projet', true);
    projDlg.showModal();
    // Clavier : directement le champ e-mail. Doigt ou souris : la fenêtre (pas de clavier qui surgit sur téléphone).
    // WebKit : un champ qu'on vient de ré-afficher ne prend le focus qu'après un calcul de mise en page (offsetWidth).
    if (e.detail === 0) { void email.offsetWidth; email.focus(); } else projDlg.focus();
  }
  projBtn.addEventListener('click', function (e) {
    if (!dims().valid) {
      var bad = showDimsErr(true) || wIn;
      goTo(bad);
      if (bad.select) bad.select();
      return;
    }
    open(e);
  });
  projDlg.addEventListener('close', function () {
    window.ppVerrou('projet', false);
    if (!projBtn.hidden) projBtn.focus({ preventScroll: true });
  });
  projDlg.addEventListener('click', function (e) {
    if (e.target === projDlg || (e.target.closest && e.target.closest('[data-proj-close]'))) projDlg.close();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted && projDlg.open) projDlg.close(); });

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (sending) return;
    var em = email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { say('Saisissez une adresse e-mail valide, par exemple prenom@exemple.fr.', true); return; }
    if (!dims().valid) { projDlg.close(); return; }
    say('');
    sending = true;
    send.disabled = true; send.textContent = 'Envoi…';
    // Projet figé avant toute attente : le client peut fermer la fenêtre et retoucher la fiche pendant l'envoi.
    var v = st.v, c = (frame(v), cropOf(v.code)), q = devis(), abo = !!news.checked, gen = ouvertures, vp = vigP;
    var body = {
      email: em, news: abo, mode: 'fiche', nom: String(D.title || '').slice(0, 120),
      scene: { handle: D.handle, variant: String(v.id), code: v.code, w: q.w, h: q.h, pw: q.pw, ph: q.ph, mat: st.mat,
        crop: { cx: c.cx, cy: c.cy, z: c.z, m: !!c.m }, prix: q.prix },
      page: lienPage()
    };
    // Petite image : 8 s au plus, sinon le projet part sans elle.
    var vig = await Promise.race([vp, new Promise(function (ok) { setTimeout(function () { ok(''); }, 8000); })]);
    if (vig) body.vig = vig;
    var r = await iaPost('/projet/save', body, 30000);
    sending = false;
    send.disabled = false; send.textContent = SEND_LABEL;
    // Fenêtre fermée ou rouverte entre-temps : la réponse ne touche pas au formulaire, un message bref suffit.
    var ici = projDlg.open && gen === ouvertures;
    if (!r.ok) {
      var t = ERR[r.error] || ERR.FAIL;
      if (!ici) showToast(t);
      else if (r.error === 'EMAIL') say(t, true);
      else { say(t); send.focus(); }
      return;
    }
    // Case cochée : inscription une fois l'e-mail du projet parti (même liste que le pied de page).
    if (abo) {
      fetch(NEWS, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: em, source: 'Studio Novomur (projet)' }) })
        .then(function (x) { return x.ok ? x.json() : null; })
        .then(function (res) { if (res && res.ok === true && window.nmInscrit) window.nmInscrit(em); })
        .catch(function () {});
    }
    if (!ici) { showToast('Votre projet est envoyé à ' + em + '.'); return; }
    $('nmsProjTo').textContent = em;
    form.hidden = true; done.hidden = false;
    title.textContent = 'C’est envoyé';
    var fait = $('nmsProjDoneTxt');
    void fait.offsetWidth; fait.focus({ preventScroll: true });
  });

  /* Lien de l'e-mail : ?projet= rouvre le projet enregistré (design, mesures, cadrage, finition). Le paramètre
     quitte ensuite l'adresse : un rechargement garde les retouches du client au lieu de rouvrir l'ancien projet. */
  var pid = null;
  try { pid = new URL(location.href).searchParams.get('projet'); } catch (e) {}
  if (pid === null) return;
  function sansParam() {
    try { var u = new URL(location.href); u.searchParams.delete('projet'); history.replaceState(history.state, '', u.toString()); } catch (e) {}
  }
  var PERDU = 'Ce lien de projet n’est plus valable. Saisissez à nouveau vos mesures, ou écrivez-nous sur WhatsApp.';
  if (!/^[A-Za-z0-9_-]{6,64}$/.test(pid)) { sansParam(); showToast(PERDU); return; }
  (async function () {
    var r;
    var ctl = window.AbortController ? new AbortController() : null;
    var to = setTimeout(function () { if (ctl) ctl.abort(); }, 15000);
    try {
      var res = await fetch(IA + '/projet/get?id=' + encodeURIComponent(pid), { signal: ctl ? ctl.signal : undefined });
      try { r = await res.json(); } catch (e) { r = null; }
      if (!r || typeof r !== 'object') r = { error: res.status === 404 ? 'ABSENT' : 'FAIL' };
    } catch (e) { r = { error: 'NET' }; }
    finally { clearTimeout(to); }
    // Réseau ou service indisponible : le paramètre reste, un rechargement réessaie.
    if (r.error === 'NET' || r.error === 'FAIL' || r.error === 'LIMIT') { showToast('Votre projet n’a pas pu être rouvert. Vérifiez votre connexion et rechargez la page.'); return; }
    sansParam();
    var sc = r.ok && r.mode === 'fiche' ? r.scene : null;
    if (!sc || sc.handle !== D.handle || !(sc.w > 0) || !(sc.h > 0)) { showToast(PERDU); return; }
    var v = byId[sc.variant];
    if (v) selectVariant(v, false);
    wIn.value = String(sc.w);
    hIn.value = String(sc.h);
    var mr = root.querySelector('input[name="nmsMat"][value="' + String(sc.mat || '').replace(/["\\]/g, '') + '"]');
    if (mr) { mr.checked = true; st.mat = mr.value; }
    var c = sc.crop;
    if (c && isFinite(c.cx) && isFinite(c.cy) && isFinite(c.z)) st.crops[sc.code] = { cx: +c.cx, cy: +c.cy, z: clamp(+c.z, 1, 3), m: !!c.m };
    showDimsErr(false);
    cropGate(true);
    render();
    showToast(v && v.ok ? 'Votre projet est rouvert : mesures, cadrage et finition.' : 'Votre projet est rouvert, mais ce design n’est plus disponible : choisissez-en un autre.');
  })();
})();

/* ---------- Message bref ---------- */
var toastT = 0;
function showToast(text) {
  var t = $('nmsToast');
  if (!t) { t = document.createElement('div'); t.id = 'nmsToast'; t.className = 'nms__toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
  t.textContent = text;
  t.classList.add('is-on');
  clearTimeout(toastT);
  toastT = setTimeout(function () { t.classList.remove('is-on'); }, 4200);
}

/* ---------- Compteur anonyme des designs (même worker que la fiche classique) ---------- */
var compte = (function () {
  var off = navigator.webdriver || (window.Shopify && window.Shopify.designMode) || /bot\b|crawl|spider|slurp|lighthouse|headless/i.test(navigator.userAgent);
  var url = String(D.workerUrl || '').replace(/\/$/, '') + '/vue-design', deja = {};
  return function (type, code) {
    code = String(code || '').trim();
    if (off || !code || deja[type + code]) return;
    deja[type + code] = 1;
    var corps = JSON.stringify({ p: D.handle, c: code, t: type });
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(url, corps)) return;
      fetch(url, { method: 'POST', body: corps, keepalive: true, mode: 'no-cors' });
    } catch (e) {}
  };
})();
if (typeof window.ppCompteDesign !== 'function') window.ppCompteDesign = compte;
if (document.visibilityState === 'visible') compte('page', st.v.code);
else document.addEventListener('visibilitychange', function wait() {
  if (document.visibilityState !== 'visible') return;
  document.removeEventListener('visibilitychange', wait);
  compte('page', st.v.code);
});

/* ---------- Entête flottant : la section commence juste dessous ---------- */
(function () {
  var hd = document.getElementById('site-header');
  if (!hd) return;
  var lastW = 0;
  // Hauteur des bandeaux au-dessus de l'entête (header.liquid : l'entête fixe remonte d'autant au défilement).
  function bars() {
    var h = 0, ann = document.getElementById('pp-announcement-bar'), tb = document.querySelector('.pp-topbar');
    if (ann && !ann.classList.contains('pp-ann--hidden')) h += ann.offsetHeight;
    if (tb && getComputedStyle(tb).display !== 'none') h += tb.offsetHeight;
    return h;
  }
  function fit(e) {
    // Barre d'adresse du téléphone (hauteur seule) : rien à recalculer, sinon la page saute en défilant.
    if (e && e.type === 'resize' && window.innerWidth === lastW) return;
    lastW = window.innerWidth;
    var y = window.pageYOffset, r = hd.getBoundingClientRect(), top = root.getBoundingClientRect().top + y;
    var fixed = getComputedStyle(hd).position === 'fixed';
    // Bas de l'entête page en haut, quelle que soit la position de défilement actuelle.
    var bottom = fixed ? r.bottom + Math.min(y, bars()) : r.bottom + y;
    var gap = window.innerWidth >= 768 ? 20 : 10;
    root.style.paddingTop = Math.max(gap, Math.round(bottom - top + gap)) + 'px';
  }
  fit();
  window.addEventListener('load', fit);
  window.addEventListener('resize', fit, { passive: true });
})();

/* ---------- Bulle Chat (Shopify Inbox) : au-dessus de la barre d'achat ----------
   La barre reste collée en bas de l'écran pendant toute la configuration, et la bulle Chat, en bas à droite
   par-dessus tout, en couvrait la moitié droite (« Saisir mes mesures », « Ajouter au panier »).
   Inbox pose sa bulle à --shopify-chat-activator-offset du bas (20 px par défaut) : tant que la barre occupe
   le bas de l'écran, la bulle se pose 12 px au-dessus. Plus bas dans la page, la barre relais de la section
   custom-product (#ppStickyAtc) écrit la même variable : on lui laisse la main. */
(function () {
  var bar = $('nmsBar');
  if (!bar) return;
  var html = document.documentElement, relais = null, attente = false;
  var ZONE = 80; // bas de l'écran occupé par la bulle : 20 px de marge et environ 50 px de bulle
  function maj() {
    attente = false;
    if (!relais) relais = document.getElementById('ppStickyAtc');
    if (relais && relais.classList.contains('is-visible')) return;
    var r = bar.getBoundingClientRect(), ih = window.innerHeight;
    var v = r.height && r.top < ih && r.bottom > ih - ZONE ? Math.round(ih - r.top + 12) + 'px' : '';
    // Comparé à la valeur en place, pas à une copie : la section custom-product peut l'avoir effacée.
    if (html.style.getPropertyValue('--shopify-chat-activator-offset') !== v) html.style.setProperty('--shopify-chat-activator-offset', v);
  }
  function bientot() { if (!attente) { attente = true; requestAnimationFrame(maj); } }
  window.addEventListener('scroll', bientot, { passive: true });
  window.addEventListener('resize', bientot, { passive: true });
  window.addEventListener('load', bientot);
  if (window.ResizeObserver) new ResizeObserver(bientot).observe(bar);
  maj();
})();

/* ---------- Démarrage ---------- */
cropGate(true);
setCropImage(st.v);
photoNav();
updateBar();
tryUi();
render();
})();
